import Img from "../assets/images/TalentDashboard/img.png";
import stanley from "../assets/images/avatars/stanley.png";
import yomi from "../assets/images/avatars/yomi.png";
import oderah from "../assets/images/avatars/oderah.png";
import gospel from "../assets/images/avatars/gospel.png";
import gabriel from "../assets/images/avatars/gabriel.png";
import henry from "../assets/images/avatars/henry.png";
import greg from "../assets/images/avatars/greg.png";
import abayomi from "../assets/images/avatars/abayomi.png";
import benjamin from "../assets/images/avatars/benjamin.png";
import fisayo from "../assets/images/avatars/fisayo.png";
import anthony from "../assets/images/avatars/anthony.png";
import ibukun from "../assets/images/avatars/ibukun.png";
import ifechukwude from "../assets/images/avatars/ifechukwude.jpeg";
import { ReactComponent as InstagramIcon } from "../assets/images/icons/instagram-white.svg";
import { ReactComponent as FacebookIcon } from "../assets/images/icons/facebook-white.svg";
import { ReactComponent as TwitterIcon } from "../assets/images/icons/twitter-white.svg";
import { ReactComponent as LinkedInIcon } from "../assets/images/icons/linkedin-white.svg";
import { checkMail } from "../utils/functions";
import ken from "../assets/images/avatars/ken.png";
import gregu from "../assets/images/avatars/gregu.png";
import chika from "../assets/images/avatars/chika.png";
import leo from "../assets/images/avatars/leo.jpeg";
import brain from "../assets/svgs/brain.svg";
import team from "../assets/svgs/team.svg";
import shield from "../assets/svgs/shield.svg";
import chat from "../assets/svgs/chat.svg";
import thunder from "../assets/svgs/thunder.svg";
import img1 from "../assets/images/AwaAI/image-1.png";
import img2 from "../assets/images/AwaAI/image-2.png";
import img3 from "../assets/images/AwaAI/image-3.png";
import img4 from "../assets/images/AwaAI/image-4.png";
import img5 from "../assets/images/AwaAI/image-5.png";
import img6 from "../assets/images/AwaAI/image-6.png";
import img7 from "../assets/images/AwaAI/image-7.png";
import img8 from "../assets/images/AwaAI/image-8.png";

export const Logo = ({ color }) => (
  <svg
    width="308"
    height="53"
    viewBox="0 0 308 53"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.9439 51.4737C26.9456 51.4726 25.9762 51.1388 25.1888 50.5252C24.463 49.9691 23.9023 49.226 23.5666 48.3756L16.1544 30.6461L8.85978 48.3533C8.53809 49.2261 7.97512 49.9896 7.23641 50.5549C6.45398 51.1519 5.4964 51.474 4.51223 51.4712C2.7539 51.4712 1.71128 50.6961 1.14663 50.046C0.443789 49.224 0.0396766 48.1884 0 47.1076L0 47.0444V46.98C0.00703099 46.4688 0.0947914 45.9619 0.260035 45.478L0.287277 45.3963L11.8304 17.1787C12.1959 16.2422 12.836 15.4381 13.6667 14.8719C14.428 14.3558 15.3263 14.0794 16.246 14.0781C16.3191 14.0781 16.3921 14.0781 16.4664 14.0781C17.4029 14.0968 18.3123 14.3962 19.0767 14.9375C19.8758 15.498 20.4849 16.289 20.8226 17.2047L32.1949 44.9282C32.426 45.5082 32.5457 46.1266 32.5478 46.7509C32.5478 48.113 32.0525 49.2956 31.1126 50.1809C30.2637 51.0061 29.1277 51.4695 27.9439 51.4737Z"
      fill={color}
    />
    <path
      d="M104.458 51.4734C103.46 51.4723 102.49 51.1385 101.703 50.5248C100.977 49.9691 100.416 49.2259 100.081 48.3752L92.6671 30.6458L85.3725 48.3529C85.0517 49.2262 84.4886 49.99 83.7491 50.5546C82.9668 51.1518 82.0092 51.4739 81.0249 51.4709C79.2666 51.4709 78.224 50.6957 77.6593 50.0456C76.9556 49.2231 76.551 48.1866 76.5115 47.1048V47.0416V46.9772C76.519 46.4666 76.6076 45.9605 76.774 45.4777L76.8012 45.396L88.3443 17.1846C88.7098 16.2481 89.35 15.4439 90.1807 14.8777C90.9419 14.3616 91.8402 14.0851 92.76 14.084C92.8318 14.084 92.9061 14.084 92.9791 14.084C93.9176 14.1013 94.8292 14.4003 95.5956 14.9421C96.3947 15.5026 97.0038 16.2936 97.3415 17.2094L108.715 44.9279C108.947 45.5077 109.067 46.1261 109.069 46.7506C109.069 48.1127 108.574 49.2953 107.634 50.1806C106.783 51.0072 105.644 51.4707 104.458 51.4734Z"
      fill={color}
    />
    <path
      d="M126.797 52.0563C124.352 52.0563 122.127 51.7046 120.183 51.01C118.239 50.3153 116.362 49.1711 114.611 47.6122C114.035 47.1746 113.571 46.6057 113.259 45.9529C112.951 45.3184 112.79 44.6225 112.79 43.9172C112.79 42.7694 113.233 41.666 114.028 40.8376C114.439 40.3909 114.939 40.0358 115.496 39.7956C116.054 39.5553 116.655 39.4353 117.262 39.4433C118.263 39.4494 119.233 39.7946 120.012 40.4228L120.083 40.4773L120.147 40.5367C121.034 41.3748 122.054 42.0587 123.166 42.56C124.146 42.9848 125.351 43.2002 126.746 43.2002C127.62 43.2117 128.489 43.061 129.308 42.7557C130 42.487 130.546 42.1366 130.918 41.7304C131.027 41.6216 131.114 41.4916 131.172 41.3483C131.23 41.2051 131.258 41.0515 131.255 40.8971C131.255 40.1677 131.032 39.8284 130.864 39.6353C130.476 39.1895 129.85 38.7908 129.007 38.4515C127.766 37.9754 126.486 37.6099 125.181 37.3593C123.636 37.0915 122.123 36.6662 120.665 36.0901C119.305 35.5549 118.045 34.7938 116.938 33.839C115.846 32.8877 114.979 31.7072 114.397 30.3817C113.816 29.0642 113.52 27.5436 113.52 25.8633C113.52 23.5279 114.157 21.4687 115.413 19.7413C116.622 18.0783 118.27 16.7843 120.31 15.894C122.265 15.0409 124.476 14.6087 126.882 14.6087C128.976 14.5964 131.057 14.9419 133.034 15.6303C134.989 16.3237 136.625 17.2883 137.878 18.4981C139.379 19.833 139.695 21.2446 139.695 22.198C139.695 23.3125 139.257 24.37 138.43 25.2553C137.563 26.1815 136.47 26.6719 135.267 26.6719C134.361 26.6817 133.48 26.379 132.771 25.815L132.648 25.7172L132.541 25.6045C132.149 25.2192 131.695 24.9038 131.196 24.6721C130.468 24.3109 129.708 24.0142 128.928 23.7855C128.264 23.5814 127.573 23.4735 126.879 23.4648C125.79 23.4648 124.875 23.6059 124.162 23.8846C123.562 24.1186 123.123 24.4096 122.854 24.7513C122.647 25.0162 122.541 25.3465 122.556 25.6825C122.556 26.3215 122.745 26.6087 122.888 26.7697C123.243 27.1697 123.792 27.5127 124.52 27.795C125.619 28.209 126.743 28.5531 127.885 28.8252C129.489 29.1667 131.072 29.6004 132.627 30.1242C134.072 30.6028 135.429 31.3179 136.641 32.2404C137.83 33.1703 138.777 34.3738 139.401 35.7484C140.02 37.1104 140.336 38.7611 140.336 40.6618C140.336 42.9811 139.661 45.0514 138.329 46.816C137.03 48.5157 135.32 49.8571 133.36 50.714C131.386 51.6043 129.174 52.0563 126.797 52.0563Z"
      fill={color}
    />
    <path
      d="M161.406 52.0566C158.968 52.0761 156.552 51.5816 154.317 50.6054C152.177 49.6632 150.253 48.2928 148.663 46.5786C147.061 44.8451 145.817 42.8127 145.002 40.5977C143.316 35.902 143.316 30.7662 145.002 26.0704C145.818 23.8576 147.063 21.827 148.663 20.0946C150.255 18.3821 152.178 17.0123 154.317 16.069C156.552 15.0928 158.968 14.5983 161.406 14.6177C163.968 14.6177 166.369 15.1056 168.541 16.069C170.68 17.0123 172.604 18.3821 174.195 20.0946C175.795 21.8281 177.044 23.8543 177.875 26.0618C179.597 30.7609 179.597 35.9184 177.875 40.6176C177.045 42.8255 175.796 44.8522 174.196 46.586C172.605 48.2989 170.681 49.6688 168.541 50.6116C166.369 51.5688 163.968 52.0566 161.406 52.0566ZM161.406 23.6509C159.788 23.6509 158.404 24.0422 157.174 24.8458C155.907 25.6765 154.892 26.8395 154.24 28.2077C153.512 29.675 153.143 31.3999 153.143 33.3341C153.143 35.241 153.515 36.9597 154.243 38.4444C154.956 39.8957 155.915 41.0002 157.174 41.8224C158.404 42.6273 159.787 43.0173 161.406 43.0173C163.057 43.0173 164.456 42.6273 165.685 41.8236C166.949 40.9965 167.913 39.887 168.645 38.4308C169.388 36.9449 169.76 35.2336 169.76 33.3341C169.76 31.4346 169.388 29.7196 168.645 28.2374C167.917 26.7812 166.948 25.6717 165.685 24.8446C164.455 24.0422 163.056 23.6509 161.406 23.6509Z"
      fill={color}
    />
    <path
      d="M197.378 51.872C194.58 51.872 192.039 51.2243 189.825 49.9464C187.614 48.6755 185.791 46.8262 184.552 44.5972C183.283 42.3448 182.639 39.7679 182.639 36.9521V19.5879C182.629 18.978 182.745 18.3725 182.98 17.8093C183.214 17.2461 183.562 16.7371 184.001 16.314C184.877 15.4682 186.029 15.0225 187.337 15.0225C188.493 15.0297 189.602 15.4826 190.433 16.2867C190.888 16.7066 191.249 17.2176 191.493 17.7864C191.737 18.3552 191.859 18.969 191.851 19.5879V36.9521C191.851 38.1743 192.098 39.1872 192.615 40.0478C193.109 40.9009 193.82 41.608 194.676 42.0971C195.49 42.5791 196.419 42.8324 197.365 42.8301C198.385 42.8437 199.392 42.5909 200.285 42.0967C201.178 41.6024 201.927 40.8839 202.458 40.0119C202.988 39.1587 203.245 38.1545 203.245 36.9496V19.5879C203.224 18.4445 203.62 17.3326 204.36 16.4601C204.925 15.8038 205.951 15.0225 207.627 15.0225C208.936 15.0225 210.064 15.5079 210.889 16.4267C211.659 17.2975 212.075 18.4254 212.055 19.5879V36.9521C212.055 39.7667 211.421 42.3361 210.172 44.586C208.951 46.8146 207.144 48.667 204.946 49.9427C202.757 51.2231 200.206 51.872 197.378 51.872Z"
      fill={color}
    />
    <path
      d="M245.73 45.7258L245.568 45.1599L243.339 37.4022C243.03 36.319 242.336 35.3862 241.387 34.7796L241.358 34.7461C241.398 34.7065 241.437 34.6669 241.476 34.6223C242.486 33.5718 243.302 32.35 243.884 31.014C244.493 29.6274 244.807 28.129 244.804 26.6145C244.804 24.3856 244.275 22.3635 243.233 20.6002C242.239 18.8946 240.825 17.4724 239.124 16.4694C237.408 15.4594 235.45 14.9335 233.458 14.9475H220.534C219.339 14.938 218.188 15.4023 217.335 16.239C216.895 16.6621 216.547 17.1711 216.313 17.7343C216.079 18.2976 215.963 18.903 215.972 19.513V46.917C215.971 47.5735 216.119 48.2218 216.405 48.8124C216.692 49.4029 217.11 49.9202 217.627 50.3247C218.568 51.0828 219.742 51.4919 220.95 51.4825C222.247 51.4825 223.393 50.96 224.178 50.0115C224.886 49.1367 225.262 48.0405 225.241 46.9158V39.1147H232.084C232.523 39.1088 232.962 39.1638 233.386 39.2782C233.647 39.3479 233.891 39.4705 234.103 39.6385C234.272 39.7835 234.405 39.9663 234.491 40.1722C234.549 40.3103 234.591 40.455 234.615 40.6031L236.821 48.289C236.963 48.7823 237.185 49.2488 237.479 49.6697C238.033 50.4597 238.82 51.0571 239.73 51.3785C240.64 51.6999 241.628 51.7293 242.556 51.4627C242.638 51.4392 242.721 51.4132 242.803 51.3835C243.922 50.9937 244.849 50.19 245.394 49.1376C245.938 48.0853 246.059 46.8643 245.73 45.7258ZM234.976 28.9548C234.76 29.4782 234.426 29.9445 233.999 30.3169C233.805 30.4976 233.562 30.6185 233.301 30.6648H225.24V23.8086H233.228C233.612 23.8086 234.08 23.8952 234.644 24.5379C235.158 25.1236 235.397 25.8294 235.397 26.7569C235.414 27.5122 235.27 28.2626 234.976 28.9585V28.9548Z"
      fill={color}
    />
    <path
      d="M267.712 51.9416C265.319 51.9538 262.943 51.5344 260.699 50.7033C258.498 49.8816 256.477 48.6406 254.749 47.0492C252.96 45.3867 251.549 43.3599 250.611 41.1055C249.626 38.7912 249.125 36.1401 249.125 33.224C249.103 30.7015 249.57 28.1987 250.5 25.8538C251.39 23.6244 252.732 21.6039 254.443 19.9201C256.146 18.2596 258.156 16.9477 260.362 16.0579C262.607 15.1428 265.079 14.6797 267.709 14.6797C269.346 14.6767 270.977 14.8848 272.561 15.2989C274.081 15.6958 275.544 16.2828 276.916 17.046C277.532 17.3496 278.065 17.7982 278.469 18.3531C278.873 18.9081 279.136 19.5529 279.236 20.2321C279.336 20.8678 279.303 21.5176 279.138 22.1398C278.974 22.762 278.681 23.3429 278.278 23.8453C277.948 24.3013 277.526 24.683 277.039 24.9658C276.552 25.2486 276.011 25.4263 275.451 25.4873C275.271 25.5082 275.09 25.5185 274.908 25.5182C274.098 25.5148 273.301 25.3119 272.587 24.9276C271.832 24.5394 271.039 24.2278 270.221 23.9977C269.402 23.7743 268.557 23.6639 267.709 23.6695C266.265 23.6695 264.968 23.8986 263.853 24.353C262.784 24.7778 261.82 25.4283 261.026 26.26C260.217 27.1148 259.593 28.1262 259.191 29.2318C258.734 30.5112 258.51 31.8619 258.528 33.2202C258.528 34.856 258.776 36.301 259.245 37.5145C259.666 38.6333 260.314 39.6524 261.15 40.5074C261.94 41.3004 262.898 41.9059 263.953 42.2794C265.159 42.7021 266.429 42.9116 267.706 42.8985C268.553 42.8996 269.397 42.7982 270.22 42.5964C271.014 42.4015 271.778 42.103 272.494 41.7085L272.534 41.6875L272.574 41.6677C273.278 41.3061 274.057 41.1148 274.848 41.1092C275.07 41.1094 275.291 41.1252 275.511 41.1563C276.057 41.2319 276.583 41.4166 277.056 41.6993C277.53 41.982 277.942 42.357 278.267 42.8019C279.43 44.2631 279.449 45.6499 279.258 46.5687C278.983 47.8763 278.193 48.9103 276.972 49.5591C276.053 50.0665 275.089 50.4868 274.092 50.8147C273.085 51.1504 272.058 51.4201 271.016 51.6221C269.927 51.8332 268.821 51.9402 267.712 51.9416Z"
      fill={color}
    />
    <path
      d="M287.631 51.4842C286.435 51.4939 285.284 51.0296 284.43 50.1927C283.99 49.7695 283.643 49.2605 283.408 48.6972C283.174 48.134 283.058 47.5286 283.068 46.9187V19.5209C283.058 18.9107 283.174 18.3051 283.408 17.7417C283.643 17.1783 283.99 16.669 284.43 16.2457C285.284 15.4097 286.434 14.9459 287.629 14.9554H303.479C304.663 14.9416 305.804 15.3965 306.653 16.2209C307.085 16.6347 307.428 17.1331 307.66 17.685C307.891 18.237 308.007 18.8307 307.999 19.4292C308.011 20.0355 307.891 20.6372 307.649 21.1929C307.406 21.7487 307.046 22.2453 306.593 22.6487C305.738 23.4134 304.626 23.8292 303.479 23.8139H292.335V28.3819H301.422C302.606 28.3682 303.747 28.8231 304.596 29.6474C305.032 30.0683 305.376 30.5745 305.608 31.1343C305.839 31.6942 305.953 32.2958 305.942 32.9015C305.954 33.5078 305.835 34.1095 305.592 34.6652C305.349 35.221 304.989 35.7176 304.537 36.121C303.681 36.8857 302.57 37.3015 301.422 37.2862H292.335V42.6306H303.479C304.074 42.6244 304.663 42.7377 305.213 42.9638C305.763 43.1899 306.262 43.5242 306.68 43.9469C307.097 44.3509 307.429 44.8347 307.655 45.3695C307.882 45.9042 307.999 46.4791 307.999 47.0598C308.008 47.6615 307.891 48.2584 307.654 48.8116C307.418 49.3648 307.067 49.862 306.626 50.2707C305.772 51.0658 304.645 51.5017 303.479 51.4879L287.631 51.4842Z"
      fill={color}
    />
    <path
      d="M42.3183 10.155C44.6414 9.19271 45.7447 6.52929 44.7824 4.2061C43.8201 1.88291 41.1567 0.779684 38.8335 1.74198C36.5103 2.70428 35.407 5.36769 36.3693 7.69089C37.3316 10.0141 39.9951 11.1173 42.3183 10.155Z"
      fill={color}
    />
    <path
      d="M70.3264 10.155C72.6496 9.19271 73.7529 6.52929 72.7906 4.2061C71.8283 1.8829 69.1648 0.779682 66.8416 1.74198C64.5185 2.70428 63.4152 5.36769 64.3775 7.69089C65.3398 10.0141 68.0032 11.1173 70.3264 10.155Z"
      fill={color}
    />
    <path
      d="M73.0492 17.0986V46.9767C73.0492 47.0423 73.0492 47.1079 73.0492 47.1723C73.0498 47.1834 73.0498 47.1946 73.0492 47.2057C73.0492 47.2627 73.0455 47.3197 73.038 47.3766C73.038 47.3964 73.038 47.415 73.038 47.4323C73.038 47.4856 73.0269 47.5376 73.0194 47.5896C73.012 47.6416 72.9996 47.7233 72.9872 47.7902C72.9867 47.7927 72.9867 47.7952 72.9872 47.7976C72.9749 47.8596 72.9625 47.9215 72.9489 47.9846C72.9482 47.9879 72.9482 47.9913 72.9489 47.9945C72.9328 48.0577 72.9167 48.1183 72.8993 48.1852L72.8931 48.2038C72.8758 48.2669 72.856 48.3276 72.8362 48.392C72.8226 48.4316 72.8089 48.4713 72.7941 48.5158C72.7792 48.5604 72.7693 48.5839 72.7557 48.6174C72.7086 48.7412 72.6554 48.8576 72.596 48.974C72.5662 49.0351 72.5353 49.0945 72.5031 49.1523L72.4944 49.1672C72.4697 49.2105 72.4449 49.2538 72.4189 49.291L72.409 49.3071L72.3644 49.3777C72.266 49.5327 72.1576 49.6812 72.04 49.8222L71.9768 49.8965C71.9533 49.9237 71.9298 49.951 71.9038 49.9782C71.8567 50.0302 71.8072 50.0822 71.7577 50.1318C71.6574 50.2333 71.5509 50.3286 71.4407 50.4203C71.3849 50.4673 71.3292 50.5107 71.2723 50.5528L71.1856 50.6159L71.0766 50.6791C71.0469 50.7001 71.0172 50.7199 70.9862 50.7385C70.9553 50.7571 70.8884 50.8017 70.8376 50.8301C70.8104 50.8475 70.7819 50.8636 70.7534 50.8784C70.5492 50.9931 70.3359 51.0908 70.1157 51.1707C70.0476 51.1954 69.977 51.219 69.9077 51.2412C69.8383 51.2635 69.7616 51.2846 69.6885 51.3032L69.5795 51.3292C69.5065 51.3465 69.4334 51.3601 69.3591 51.3737C69.201 51.4017 69.0414 51.4212 68.8812 51.4319L68.7078 51.4406H68.584C68.5184 51.4406 68.4515 51.4406 68.3859 51.4406H68.3524C68.2955 51.4406 68.2385 51.4406 68.1815 51.4282H68.1258C68.0738 51.4233 68.0218 51.4171 67.9698 51.4096C67.9017 51.3997 67.8348 51.3898 67.7667 51.3775L67.576 51.3378H67.5661C67.4993 51.3217 67.4336 51.3044 67.3668 51.2858L67.1736 51.2264L67.0498 51.1843L66.9693 51.1546C66.7784 51.0799 66.5926 50.9926 66.4133 50.8933L66.3984 50.8846C66.3551 50.8599 66.3118 50.8351 66.2746 50.8091C66.1941 50.7596 66.1149 50.7088 66.0369 50.6543C65.9849 50.6172 65.9329 50.58 65.8821 50.5404C65.8664 50.5297 65.8503 50.5173 65.8338 50.5032L65.7199 50.4116C65.6592 50.3608 65.5961 50.3076 65.5416 50.2531L65.5094 50.2222L54.5854 40.0139L43.6602 50.2222L43.628 50.2531C43.5698 50.3076 43.5104 50.3608 43.4497 50.4116C43.389 50.4624 43.3469 50.4958 43.2949 50.5354C43.2429 50.5751 43.1822 50.6196 43.1253 50.6593L43.1141 50.6667C43.072 50.6964 43.0299 50.7249 42.9903 50.7521C42.9507 50.7794 42.9296 50.7905 42.8987 50.8091C42.8677 50.8277 42.8132 50.8599 42.7749 50.8846L42.7588 50.8933C42.7006 50.9255 42.6411 50.9577 42.5829 50.9862C42.4591 51.0493 42.3353 51.11 42.204 51.1546L42.1235 51.1843L41.9997 51.2264L41.8065 51.2858C41.7409 51.3044 41.674 51.3217 41.6072 51.3378H41.5973L41.4103 51.3762H41.4029C41.3372 51.3886 41.2704 51.3997 41.2035 51.4084C41.1366 51.4171 41.0982 51.422 41.045 51.427L40.9856 51.4332C40.9303 51.4381 40.8745 51.4418 40.8184 51.4443H40.7837C40.7193 51.4443 40.6599 51.4443 40.5918 51.4443H40.4581C40.4023 51.4443 40.3479 51.4443 40.2934 51.4369H40.255L40.1695 51.4295C40.0866 51.422 40.0036 51.4121 39.9219 51.3997C39.7367 51.3696 39.5535 51.3282 39.3733 51.2759H39.3672C39.2619 51.2462 39.1579 51.2115 39.0551 51.1744C38.9833 51.1484 38.9127 51.1199 38.8421 51.0902C38.7715 51.0605 38.7034 51.0295 38.6353 50.9961C38.5672 50.9626 38.4892 50.923 38.4174 50.8822C38.3889 50.8673 38.3604 50.8512 38.3332 50.8339C37.9612 50.6162 37.6229 50.3455 37.329 50.0302C37.3237 50.0248 37.3187 50.019 37.3141 50.0129C37.2794 49.977 37.246 49.9398 37.2138 49.9027L37.1742 49.8556C37.1308 49.8049 37.0887 49.7529 37.0504 49.7008L37.0145 49.6526C36.9823 49.6105 36.9513 49.5671 36.9203 49.5225C36.8894 49.478 36.8399 49.4049 36.8027 49.3442C36.7656 49.2836 36.7321 49.2278 36.6987 49.1684C36.6653 49.109 36.6207 49.026 36.586 48.9542C36.5637 48.9096 36.5427 48.865 36.5216 48.8192L36.503 48.7759C36.4795 48.7239 36.4572 48.6718 36.4374 48.6186C36.4238 48.5852 36.4102 48.5505 36.399 48.5171C36.3879 48.4836 36.3705 48.4378 36.3569 48.3932C36.3359 48.3301 36.3173 48.2694 36.3 48.205C36.2974 48.199 36.2953 48.1928 36.2938 48.1865C36.2764 48.1233 36.2591 48.0626 36.2443 47.9958C36.245 47.9925 36.245 47.9891 36.2443 47.9859C36.2306 47.9239 36.217 47.862 36.2059 47.7989C36.2053 47.7964 36.2053 47.7939 36.2059 47.7914C36.1935 47.7246 36.1823 47.6577 36.1737 47.5908C36.165 47.524 36.16 47.4868 36.1551 47.4336C36.1538 47.415 36.1538 47.3964 36.1551 47.3779C36.1489 47.3209 36.1452 47.2639 36.1427 47.207C36.142 47.1958 36.142 47.1847 36.1427 47.1735C36.1427 47.1092 36.1427 47.0435 36.1427 46.9779V17.0986C36.1427 16.4418 36.4036 15.8119 36.8681 15.3474C37.3325 14.883 37.9624 14.6221 38.6192 14.6221H38.878C40.5201 14.6221 42.0949 15.2744 43.256 16.4355C44.4171 17.5966 45.0694 19.1713 45.0694 20.8134V36.6954L51.1975 30.9696L51.5826 30.6093C52.4014 29.8372 53.4842 29.4072 54.6096 29.4072C55.7349 29.4072 56.8178 29.8372 57.6365 30.6093L58.029 30.9808L64.151 36.7003V20.8134C64.151 19.1713 64.8033 17.5966 65.9644 16.4355C67.1255 15.2744 68.7003 14.6221 70.3423 14.6221H70.6011C71.253 14.6296 71.8756 14.8938 72.3339 15.3574C72.7922 15.8211 73.0492 16.4467 73.0492 17.0986Z"
      fill={color}
    />
  </svg>
);

export const abilities = [
  {
    name: "organized",
    value: "Organized",
  },
  {
    name: "pressure",
    value: "Stress tolerance",
  },
  {
    name: "collaboration",
    value: "Collaboration",
  },
  {
    name: "planning",
    value: "Judgement",
  },
  {
    name: "teamWork",
    value: "Teamwork",
  },
  {
    name: "teamManagement",
    value: "Responsibility",
  },
  {
    name: "sales",
    value: "Adaptability",
  },
  {
    name: "clientRelationship",
    value: "Clarity",
  },
  {
    name: "creativity",
    value: "Creativity",
  },
  {
    name: "communication",
    value: "Communication",
  },
];

export const abilitiesResult = [
  { skill: "Responsibility", id: "teamManagement" },
  { skill: "Teamwork", id: "teamWork" },
  { skill: "Stress tolerance", id: "pressure" },
  { skill: "Collaboration", id: "collaboration" },
  { skill: "Judgement", id: "planning" },
  { skill: "Organized", id: "organized" },
  { skill: "Communication", id: "clientRelationship" },
  { skill: "Clarity", id: "clientRelationship" },
  { skill: "Creativity", id: "creativity" },
  { skill: "Adaptability", id: "sales" },
];

export const companyType = [
  {
    text: "Individual",
    img: (
      <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.9863 4C14.0472 4 15.0646 4.42143 15.8148 5.17157C16.5649 5.92172 16.9863 6.93913 16.9863 8C16.9863 9.06086 16.5649 10.0783 15.8148 10.8284C15.0646 11.5786 14.0472 12 12.9863 12C11.9255 12 10.908 11.5786 10.1579 10.8284C9.40775 10.0783 8.98633 9.06086 8.98633 8C8.98633 6.93913 9.40775 5.92172 10.1579 5.17157C10.908 4.42143 11.9255 4 12.9863 4ZM12.9863 6C12.4559 6 11.9472 6.21071 11.5721 6.58579C11.197 6.96086 10.9863 7.46957 10.9863 8C10.9863 8.53043 11.197 9.03914 11.5721 9.41421C11.9472 9.78928 12.4559 10 12.9863 10C13.5168 10 14.0255 9.78928 14.4005 9.41421C14.7756 9.03914 14.9863 8.53043 14.9863 8C14.9863 7.46957 14.7756 6.96086 14.4005 6.58579C14.0255 6.21071 13.5168 6 12.9863 6ZM12.9863 13C15.6563 13 20.9863 14.33 20.9863 17V20H4.98633V17C4.98633 14.33 10.3163 13 12.9863 13ZM12.9863 14.9C10.0163 14.9 6.88633 16.36 6.88633 17V18.1H19.0863V17C19.0863 16.36 15.9563 14.9 12.9863 14.9Z"
          fill="#4E4E4E"
        />
      </svg>
    ),
  },
  {
    text: "Company",
    img: (
      <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.48633 10H5.48633V17H7.48633V10ZM13.4863 10H11.4863V17H13.4863V10ZM21.9863 19H2.98633V21H21.9863V19ZM19.4863 10H17.4863V17H19.4863V10ZM12.4863 3.26L17.6963 6H7.27633L12.4863 3.26ZM12.4863 1L2.98633 6V8H21.9863V6L12.4863 1Z"
          fill="#4E4E4E"
        />
      </svg>
    ),
  },
];

export const priorites = [
  "Work Life Balance",
  "Top Brands",
  "Vacation Package",
  "Work Benefits",
];

export const Briefcase = ({ color }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 6.5H16V5.5C16 4.70435 15.6839 3.94129 15.1213 3.37868C14.5587 2.81607 13.7956 2.5 13 2.5H11C10.2044 2.5 9.44129 2.81607 8.87868 3.37868C8.31607 3.94129 8 4.70435 8 5.5V6.5H5C4.20435 6.5 3.44129 6.81607 2.87868 7.37868C2.31607 7.94129 2 8.70435 2 9.5V18.5C2 19.2956 2.31607 20.0587 2.87868 20.6213C3.44129 21.1839 4.20435 21.5 5 21.5H19C19.7956 21.5 20.5587 21.1839 21.1213 20.6213C21.6839 20.0587 22 19.2956 22 18.5V9.5C22 8.70435 21.6839 7.94129 21.1213 7.37868C20.5587 6.81607 19.7956 6.5 19 6.5ZM10 5.5C10 5.23478 10.1054 4.98043 10.2929 4.79289C10.4804 4.60536 10.7348 4.5 11 4.5H13C13.2652 4.5 13.5196 4.60536 13.7071 4.79289C13.8946 4.98043 14 5.23478 14 5.5V6.5H10V5.5ZM20 18.5C20 18.7652 19.8946 19.0196 19.7071 19.2071C19.5196 19.3946 19.2652 19.5 19 19.5H5C4.73478 19.5 4.48043 19.3946 4.29289 19.2071C4.10536 19.0196 4 18.7652 4 18.5V13C4.97544 13.3869 5.97818 13.7011 7 13.94V14.53C7 14.7952 7.10536 15.0496 7.29289 15.2371C7.48043 15.4246 7.73478 15.53 8 15.53C8.26522 15.53 8.51957 15.4246 8.70711 15.2371C8.89464 15.0496 9 14.7952 9 14.53V14.32C9.99435 14.4554 10.9965 14.5255 12 14.53C13.0035 14.5255 14.0057 14.4554 15 14.32V14.53C15 14.7952 15.1054 15.0496 15.2929 15.2371C15.4804 15.4246 15.7348 15.53 16 15.53C16.2652 15.53 16.5196 15.4246 16.7071 15.2371C16.8946 15.0496 17 14.7952 17 14.53V13.94C18.0218 13.7011 19.0246 13.3869 20 13V18.5ZM20 10.81C19.0274 11.2205 18.0244 11.5548 17 11.81V11.5C17 11.2348 16.8946 10.9804 16.7071 10.7929C16.5196 10.6054 16.2652 10.5 16 10.5C15.7348 10.5 15.4804 10.6054 15.2929 10.7929C15.1054 10.9804 15 11.2348 15 11.5V12.24C13.0113 12.54 10.9887 12.54 9 12.24V11.5C9 11.2348 8.89464 10.9804 8.70711 10.7929C8.51957 10.6054 8.26522 10.5 8 10.5C7.73478 10.5 7.48043 10.6054 7.29289 10.7929C7.10536 10.9804 7 11.2348 7 11.5V11.83C5.97562 11.5748 4.9726 11.2405 4 10.83V9.5C4 9.23478 4.10536 8.98043 4.29289 8.79289C4.48043 8.60536 4.73478 8.5 5 8.5H19C19.2652 8.5 19.5196 8.60536 19.7071 8.79289C19.8946 8.98043 20 9.23478 20 9.5V10.81Z"
      fill={color || "#D3D3D3"}
    />
  </svg>
);

export const Location = ({ color }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.0009 4.47942C16.4096 2.88812 14.2513 1.99414 12.0009 1.99414C9.75047 1.99414 7.59221 2.88812 6.00091 4.47942C4.40961 6.07072 3.51563 8.22899 3.51563 10.4794C3.51562 12.7299 4.40961 14.8881 6.00091 16.4794L11.2709 21.7594C11.3639 21.8532 11.4745 21.9275 11.5963 21.9783C11.7182 22.0291 11.8489 22.0552 11.9809 22.0552C12.1129 22.0552 12.2436 22.0291 12.3655 21.9783C12.4873 21.9275 12.5979 21.8532 12.6909 21.7594L18.0009 16.4294C19.5856 14.8447 20.4758 12.6955 20.4758 10.4544C20.4758 8.21337 19.5856 6.0641 18.0009 4.47942ZM16.5709 14.9994L12.0009 19.5894L7.43091 14.9994C6.52805 14.0957 5.91338 12.9447 5.6646 11.6917C5.41582 10.4388 5.54409 9.14017 6.03321 7.9601C6.52233 6.78004 7.35032 5.77147 8.41254 5.0619C9.47475 4.35233 10.7235 3.9736 12.0009 3.9736C13.2783 3.9736 14.5271 4.35233 15.5893 5.0619C16.6515 5.77147 17.4795 6.78004 17.9686 7.9601C18.4577 9.14017 18.586 10.4388 18.3372 11.6917C18.0884 12.9447 17.4738 14.0957 16.5709 14.9994ZM9.00091 7.40942C8.19362 8.21919 7.7403 9.31599 7.7403 10.4594C7.7403 11.6029 8.19362 12.6997 9.00091 13.5094C9.60067 14.1102 10.3645 14.5205 11.1966 14.6888C12.0286 14.8571 12.8919 14.776 13.678 14.4556C14.4641 14.1351 15.1381 13.5897 15.6154 12.8877C16.0927 12.1856 16.352 11.3583 16.3609 10.5094C16.3654 9.94263 16.2562 9.38068 16.0398 8.85681C15.8234 8.33294 15.5041 7.85778 15.1009 7.45942C14.7046 7.054 14.232 6.73096 13.7103 6.50889C13.1887 6.28682 12.6282 6.1701 12.0613 6.16545C11.4944 6.1608 10.9321 6.26832 10.4069 6.48181C9.88165 6.6953 9.40383 7.01055 9.00091 7.40942ZM13.6909 12.0894C13.3119 12.4742 12.8111 12.7153 12.274 12.7717C11.7369 12.828 11.197 12.6961 10.7464 12.3983C10.2959 12.1006 9.9627 11.6557 9.80391 11.1395C9.64512 10.6233 9.67056 10.0681 9.87586 9.56858C10.0812 9.06909 10.4536 8.65644 10.9295 8.40116C11.4054 8.14588 11.9552 8.06383 12.4848 8.16904C13.0145 8.27425 13.4912 8.56018 13.8334 8.97795C14.1756 9.39573 14.3621 9.91939 14.3609 10.4594C14.3464 11.0767 14.0874 11.6629 13.6409 12.0894H13.6909Z"
      fill={color || "#D3D3D3"}
    />
  </svg>
);

export const LinkedIn = ({ color }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.332 6.66699C14.6581 6.66699 15.9299 7.19378 16.8676 8.13146C17.8052 9.06914 18.332 10.3409 18.332 11.667V17.5003H14.9987V11.667C14.9987 11.225 14.8231 10.801 14.5105 10.4885C14.198 10.1759 13.7741 10.0003 13.332 10.0003C12.89 10.0003 12.4661 10.1759 12.1535 10.4885C11.841 10.801 11.6654 11.225 11.6654 11.667V17.5003H8.33203V11.667C8.33203 10.3409 8.85882 9.06914 9.7965 8.13146C10.7342 7.19378 12.0059 6.66699 13.332 6.66699V6.66699Z"
      stroke={color || "#D3D3D3"}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.66602 7.5H4.99935V17.5H1.66602V7.5Z"
      stroke={color || "#D3D3D3"}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.33268 5.00033C4.25316 5.00033 4.99935 4.25413 4.99935 3.33366C4.99935 2.41318 4.25316 1.66699 3.33268 1.66699C2.41221 1.66699 1.66602 2.41318 1.66602 3.33366C1.66602 4.25413 2.41221 5.00033 3.33268 5.00033Z"
      stroke={color || "#D3D3D3"}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Website = ({ color }) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_334_182)">
      <path
        d="M17.2239 6.27566C17.0935 6.24959 16.9958 6.23656 16.9306 6.23656C16.4484 6.23656 16.0313 6.39948 15.6794 6.72532C14.8843 6.37341 14.1414 6.08667 13.4506 5.8651C12.3167 5.50016 11.1307 5.20039 9.89247 4.96579C9.77517 4.65298 9.59922 4.39231 9.36461 4.18377C9.69045 2.64581 10.1271 1.25122 10.6745 0C12.3167 0.117302 13.8253 0.593027 15.2004 1.42717C16.5754 2.26132 17.6865 3.35614 18.5337 4.71163C18.0515 5.23298 17.6149 5.75432 17.2239 6.27566ZM8.15249 3.73412C7.81362 3.73412 7.4943 3.82535 7.19453 4.00782C6.13881 3.22581 5.07657 2.56109 4.00782 2.01369C5.62398 0.78853 7.43565 0.117302 9.44281 0C8.93451 1.13392 8.52395 2.37862 8.21114 3.73412H8.15249ZM1.36852 4.94624C1.81167 4.20332 2.37211 3.49951 3.04985 2.8348C3.93614 3.29097 4.855 3.85142 5.80645 4.51613C4.12512 4.47703 2.64581 4.6204 1.36852 4.94624ZM6.27566 5.72825C6.30173 6.13229 6.44184 6.48746 6.69599 6.79374C6.95015 7.10003 7.26621 7.30531 7.64418 7.40958C7.56598 8.32193 7.52688 9.18866 7.52688 10.0098C7.52688 10.5833 7.54643 11.2414 7.58553 11.9844C7.29879 12.0756 7.04464 12.232 6.82307 12.4536C6.11926 12.1799 5.44151 11.8671 4.78983 11.5152C4.9332 11.2284 5.00489 10.9352 5.00489 10.6354C5.00489 10.114 4.82242 9.6709 4.45748 9.30596C4.09254 8.94102 3.6494 8.75855 3.12805 8.75855C2.55458 8.75855 2.07885 8.98012 1.70088 9.42326C1.15347 8.92799 0.664712 8.41316 0.234604 7.87879C0.351906 7.31834 0.527859 6.76442 0.762463 6.21701C2.35256 5.77387 4.19029 5.61095 6.27566 5.72825ZM1.27077 10.7918C1.30987 11.274 1.50863 11.6813 1.86706 12.0137C2.22548 12.346 2.64581 12.5122 3.12805 12.5122C3.27142 12.5122 3.42783 12.4862 3.59726 12.434C4.43141 12.9163 5.32421 13.3333 6.27566 13.6852V13.7634C6.27566 14.2717 6.44835 14.7051 6.79374 15.0635C7.13913 15.422 7.56598 15.6142 8.07429 15.6403C8.40013 17.2304 8.85631 18.6836 9.44281 20C8.13946 19.9218 6.90779 19.6057 5.7478 19.0518C4.58781 18.4979 3.58749 17.7778 2.74682 16.8915C1.90616 16.0052 1.23819 14.9625 0.742913 13.7634C0.247638 12.5644 0 11.3131 0 10.0098C0 9.99674 0.00651678 9.82079 0.0195503 9.48192C0.38449 9.93809 0.801564 10.3747 1.27077 10.7918ZM9.79472 14.6432C10.7331 14.8126 11.6781 14.9234 12.6295 14.9756C12.7208 15.2362 12.8641 15.4774 13.0596 15.6989C12.7599 17.0674 12.5774 18.3969 12.5122 19.6872C11.8475 19.8566 11.2349 19.9609 10.6745 20C10.0619 18.6054 9.58618 17.0283 9.24731 15.2688C9.48192 15.1124 9.66439 14.9039 9.79472 14.6432ZM15.8553 15.5816C16.0248 15.3731 16.1421 15.1515 16.2072 14.9169C17.1587 14.8387 18.0775 14.7149 18.9638 14.5455C18.3382 15.7706 17.478 16.8328 16.3832 17.7322C16.2659 17.0544 16.0899 16.3376 15.8553 15.5816ZM12.6686 13.7243C11.7563 13.6722 10.857 13.5549 9.97067 13.3724C9.8273 12.7208 9.45585 12.2711 8.85631 12.0235C8.80417 11.2545 8.7781 10.5833 8.7781 10.0098C8.7781 9.14956 8.8172 8.25676 8.89541 7.33138C8.92147 7.33138 8.95406 7.31834 8.99316 7.29228C9.03226 7.26621 9.05832 7.25318 9.07136 7.25318C9.57967 7.74845 10.0228 8.20463 10.4008 8.6217C11.5347 9.87292 12.4992 11.2936 13.2942 12.8837C13.0075 13.1052 12.799 13.3855 12.6686 13.7243ZM14.4086 16.2659C14.4347 16.2659 14.5064 16.2594 14.6237 16.2463C14.8452 17.0414 15.0081 17.8299 15.1124 18.6119C14.7344 18.8335 14.2783 19.0551 13.7439 19.2766C13.8351 18.26 13.9915 17.2499 14.2131 16.2463C14.3174 16.2594 14.3825 16.2659 14.4086 16.2659ZM14.3109 11.5934C14.2978 11.6194 14.2815 11.6585 14.262 11.7107C14.2424 11.7628 14.2261 11.8019 14.2131 11.828C13.392 10.3421 12.4275 8.99316 11.3196 7.78104C10.9156 7.32486 10.4334 6.82959 9.87292 6.29521C9.88596 6.29521 9.89573 6.28544 9.90225 6.26588L9.91202 6.23656C11.0068 6.45813 12.056 6.73183 13.0596 7.05767C13.6722 7.25318 14.3434 7.51385 15.0733 7.83969C15.0472 7.97002 15.0342 8.06777 15.0342 8.13294C15.0342 8.52395 15.1515 8.88237 15.3861 9.20821C14.956 10.0293 14.5976 10.8244 14.3109 11.5934ZM15.2297 12.7273C15.3861 12.2711 15.4643 12.0365 15.4643 12.0235C15.725 11.3718 16.0508 10.6745 16.4418 9.93157C16.6113 9.98371 16.7742 10.0098 16.9306 10.0098C17.3737 10.0098 17.7713 9.85989 18.1232 9.56012C18.7618 10.0033 19.3874 10.4985 20 11.0459C19.9218 11.7889 19.7654 12.5057 19.5308 13.1965C18.462 13.4181 17.3346 13.5745 16.1486 13.6657C15.9791 13.2486 15.6729 12.9358 15.2297 12.7273ZM18.8074 8.11339C18.8074 7.68328 18.6641 7.29228 18.3773 6.94037C18.651 6.58847 18.9247 6.26914 19.1984 5.9824C19.6676 7.05116 19.9413 8.15249 20.0196 9.28641C19.5894 8.96057 19.1724 8.66732 18.7683 8.40665C18.7944 8.28934 18.8074 8.19159 18.8074 8.11339Z"
        fill={color || "#D3D3D3"}
      />
    </g>
    <defs>
      <clipPath id="clip0_334_182">
        <rect width="20.02" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Line = ({ color }) => (
  <svg
    width="6"
    height="36"
    viewBox="0 0 6 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line x1="3" y1="2" x2="3" y2="34" stroke="#C8C5C5" strokeWidth="2" />
    <circle cx="3" cy="3" r="3" fill="#030659" />
    <circle cx="3" cy="3" r="3" fill="#030659" />
    <circle cx="3" cy="3" r="3" fill="#030659" />
    <circle cx="3" cy="33" r="3" fill="#030659" />
    <circle cx="3" cy="33" r="3" fill="#030659" />
    <circle cx="3" cy="33" r="3" fill={color || "#F9A910"} />
  </svg>
);

export const jobsArr = [
  {
    img: Img,
    description: "Sign Production Leader",
    location: "Gidimo",
    address: "Seatle, WA, USA | Toronto, Canada.....",
    amount: "$1000",
  },
  {
    img: Img,
    description: "Sign Production Leader",
    location: "Gidimo",
    address: "Seatle, WA, USA | Toronto, Canada.....",
    amount: "$1000",
  },
  {
    img: Img,
    description: "Sign Production Leader",
    location: "Gidimo",
    address: "Seatle, WA, USA | Toronto, Canada.....",
    amount: "$1000",
  },
  {
    img: Img,
    description: "Sign Production Leader",
    location: "Gidimo",
    address: "Seatle, WA, USA | Toronto, Canada.....",
    amount: "$1000",
  },
  {
    img: Img,
    description: "Sign Production Leader",
    location: "Gidimo",
    address: "Seatle, WA, USA | Toronto, Canada.....",
    amount: "$1000",
  },
  {
    img: Img,
    description: "Sign Production Leader",
    location: "Gidimo",
    address: "Seatle, WA, USA | Toronto, Canada.....",
    amount: "$1000",
  },
];

export const companySize = [
  {
    number: 0,
    employees: "1 - 10 employees",
  },
  {
    number: 1,
    employees: "10 - 50 employees",
  },
  {
    number: 2,
    employees: "50 - 200 employees",
  },
  {
    number: 3,
    employees: "200 - 500 employees",
  },
  {
    number: 4,
    employees: "1k - 2k employees",
  },
  {
    number: 5,
    employees: "2k - 10k employees",
  },
  {
    number: 6,
    employees: "10k - 50k employees",
  },
  {
    number: 7,
    employees: "100k+ employees",
  },
];

export {
  TERMS_OF_SERVICE_META,
  TERMSTABLEOFCONTENT,
  TERMSOFSERVICE,
} from "./termsOfService";


export const POLICYTABLEOFCONTENT = [
  "INTRODUCTION",
  "PERSONAL DATA WE COLLECT",
  "HOW WE COLLECT YOUR DATA",
  "PURPOSES FOR WHICH WE PROCESS PERSONAL DATA",
  "LEGAL BASIS FOR PROCESSING",
  "AI PROCESSING AND PROFILING",
  "DATA SHARING AND DISCLOSURE",
  "BROCHURE, CALCULATOR AND ENQUIRY FORMS",
  "COOKIES AND SIMILAR TECHNOLOGIES",
  "VISITORS IN THE UNITED KINGDOM AND EUROPEAN UNION",
  "YOUR RIGHTS AS A DATA SUBJECT",
  "DATA SECURITY",
  "DATA RETENTION",
  "CHILDREN'S PRIVACY",
  "THIRD-PARTY LINKS",
  "UPDATES TO THIS POLICY",
  "CONTACT INFORMATION",
];

export const PRIVACY_POLICY_META = {
  lastUpdated: "October 13, 2026",
};

export const PRIVACYPOLICY = [
  {
    title: "INTRODUCTION",
    blocks: [
      {
        type: "paragraph",
        text: `Welcome to Awasource ("Awasource", "Company", "we", "us" or "our").`,
      },
      {
        type: "paragraph",
        text: `Awasource is a technology-driven talent intelligence and recruitment platform that leverages data analytics, artificial intelligence ("AI"), and human expertise to connect employers with qualified professionals through recruitment, talent assessment, candidate matching, and related workforce solutions.`,
      },
      {
        type: "paragraph",
        text: `We recognize that your privacy is important and are committed to protecting your Personal Data in a lawful, fair, transparent, and secure manner. This Privacy Policy ("Policy") explains how we collect, use, disclose, store, transfer, and otherwise process your Personal Data when you access or use our website, mobile applications, products, services, assessments, communications, and any other services made available by Awasource (collectively, the "Platform").`,
      },
      {
        type: "paragraph",
        text: `This Policy applies to all individuals whose Personal Data we process in connection with the Platform, including job applicants and candidates ("Talents"), employers, recruiters, corporate clients, website visitors, business partners, service providers, and any other individuals who interact with us.`,
      },
      {
        type: "paragraph",
        text: "This Policy has been prepared in accordance with the provisions of-",
      },
      {
        type: "list",
        items: [
          `the Nigeria Data Protection Act, 2023 ("NDPA"), and`,
          `the General Application and Implementation Directive, 2025 ("GAID"), and`,
          "any other applicable data protection laws.",
        ],
      },
      {
        type: "paragraph",
        text: `By accessing or using the Platform, creating an account, submitting your Personal Data, or otherwise interacting with us, you acknowledge that you have read and understood this Privacy Policy. Where processing is based on your consent, you may withdraw your consent at any time in accordance with this Policy and applicable law. Withdrawal of consent shall not affect the lawfulness of any processing carried out before such withdrawal. Where you do not agree with this Policy or the manner in which we process your Personal Data, you should refrain from accessing or using the Platform or providing us with your Personal Data.`,
      },
    ],
  },

  {
    title: "PERSONAL DATA WE COLLECT",
    blocks: [
      {
        type: "paragraph",
        text: `The categories of Personal Data we collect depend on how you interact with the Platform, the services you use, and whether you access the Platform as a Talent, Client, website visitor, or other user. We collect only the Personal Data that is reasonably necessary to provide our services, fulfil our contractual and legal obligations, protect our legitimate interests, and otherwise achieve the purposes described in this Privacy Policy.<br/><br/>The categories of Personal Data we may collect include:`,
      },
      {
        type: "subsection",
        heading: "2.1 Identity and Contact Information",
        blocks: [
          {
            type: "paragraph",
            text: "We may collect information that identifies or enables us to communicate with you, including:",
          },
          {
            type: "list",
            items: [
              "your full name;",
              "email address;",
              "telephone number;",
              "residential or business address, where applicable;",
              "country and location;",
              "date of birth, where required;",
              "profile photograph, where voluntarily provided; and",
              "any other contact information you choose to provide.",
            ],
          },
        ],
      },
      {
        type: "subsection",
        heading: "2.2 Professional and Recruitment Information",
        blocks: [
          {
            type: "paragraph",
            text: "Where you create a Talent profile or participate in recruitment activities through the Platform, we may collect:",
          },
          {
            type: "list",
            items: [
              "curriculum vitae (CV) or résumé;",
              "employment history;",
              "educational qualifications;",
              "professional certifications;",
              "technical and professional skills;",
              "work preferences;",
              "salary expectations, where voluntarily provided;",
              "references or referee details, where submitted;",
              "portfolio links or professional profiles; and",
              "any additional recruitment-related information you choose to provide.",
            ],
          },
        ],
      },
      {
        type: "subsection",
        heading: "2.3 Assessment and AI-Generated Information",
        blocks: [
          {
            type: "paragraph",
            text: "To provide our recruitment, assessment, and talent intelligence services, we may collect or generate information relating to your use of our assessment tools and AI-enabled services, including:",
          },
          {
            type: "list",
            items: [
              "psychometric assessment responses;",
              "behavioural and personality assessment results;",
              "logical reasoning and aptitude test results;",
              "technical assessment results;",
              "AI-generated candidate scores;",
              "role-fit recommendations;",
              "skills analyses;",
              "recruitment insights; and",
              "other outputs generated through our automated systems.",
            ],
          },
          {
            type: "paragraph",
            text: "Where AI-generated outputs are created, they are used as decision-support tools and are not intended to replace appropriate human review or decision-making.",
          },
        ],
      },
      {
        type: "subsection",
        heading: "2.4 Employer and Business Information",
        blocks: [
          {
            type: "paragraph",
            text: "Where you register or use the Platform as a Client, employer, recruiter, or organisation, we may collect information including:",
          },
          {
            type: "list",
            items: [
              "company name;",
              "company registration number",
              "Tax Identification Number (TIN), where applicable;",
              "company address;",
              "industry or sector;",
              "company type;",
              "company size;",
              "name and job title of the authorised representative;",
              "business email address;",
              "business telephone number; and",
              "any other information reasonably required to verify your identity, your organisation, or your authority to act on its behalf, or to provide our services.",
            ],
          },
        ],
      },
      {
        type: "subsection",
        heading: "2.5 Account and Platform Usage Information",
        blocks: [
          {
            type: "paragraph",
            text: "When you access or use the Platform, we may automatically collect certain technical and usage information, including:",
          },
          {
            type: "list",
            items: [
              "Internet Protocol (IP) address;",
              "browser type and version;",
              "device type and operating system;",
              "device identifiers;",
              "log files;",
              "access dates and times;",
              "pages viewed;",
              "Platform interactions;",
              "referral URLs; and",
              "diagnostic, performance, and analytics information.",
            ],
          },
        ],
      },
      {
        type: "subsection",
        heading: "2.6 Payment and Transaction Information",
        blocks: [
          {
            type: "paragraph",
            text: "Where you purchase credits or other paid services through the Platform, we may collect information relating to the transaction, including:",
          },
          {
            type: "list",
            items: [
              "billing information;",
              "payment confirmations;",
              "transaction records;",
              "purchased services or credits; and",
              "other information necessary to facilitate payment processing.",
            ],
          },
          {
            type: "paragraph",
            text: "Payment card details and other financial credentials are processed by our authorized third-party payment service providers in accordance with their respective privacy policies and applicable law. Except where necessary, Awasource does not store your complete payment card information.",
          },
        ],
      },
      {
        type: "subsection",
        heading: "2.7 Communications",
        blocks: [
          {
            type: "paragraph",
            text: "We may collect information contained in communications between you and Awasource, including:",
          },
          {
            type: "list",
            items: [
              "customer support requests;",
              "emails;",
              "feedback;",
              "complaints;",
              "enquiries;",
              "survey responses; and",
              "any other correspondence you send to us.",
            ],
          },
        ],
      },
      {
        type: "subsection",
        heading: "2.8 Sensitive Personal Data",
        blocks: [
          {
            type: "paragraph",
            text: "In limited circumstances, we may process Sensitive Personal Data where it is voluntarily provided by you, required for the provision of our services, or otherwise permitted or required under Applicable Data Protection Laws.",
          },
          {
            type: "paragraph",
            text: "For example, this may include information relating to health or disability where provided to facilitate workplace accessibility or recruitment accommodations.",
          },
          {
            type: "paragraph",
            text: "Where required by law, we will process Sensitive Personal Data only on an appropriate lawful basis and implement additional safeguards commensurate with the nature and sensitivity of such information.",
          },
        ],
      },
    ],
  },

  {
    title: "HOW WE COLLECT YOUR DATA",
    blocks: [
      {
        type: "paragraph",
        text: "We collect Personal Data through a variety of sources depending on how you interact with the Platform and the services you use. In most cases, we collect Personal Data directly from you; however, we may also collect or generate information from other lawful sources.",
      },
      {
        type: "subsection",
        heading: "3.1 Information You Provide Directly",
        blocks: [
          {
            type: "paragraph",
            text: "We collect Personal Data that you voluntarily provide when you:",
          },
          {
            type: "list",
            items: [
              "create or register an account;",
              "complete your user profile;",
              "upload your curriculum vitae (CV), résumé, portfolio, or other professional documents;",
              "complete psychometric, technical, aptitude, behavioural, or other assessments available through the Platform;",
              "purchase paid services;",
              "communicate with us through email, customer support, surveys, or other channels;",
              "participate in promotions, events, webinars, or other activities organised by Awasource; or",
              "otherwise submit information through the Platform.",
            ],
          },
          {
            type: "paragraph",
            text: "You are responsible for ensuring that the Personal Data you provide is accurate, complete, and kept up to date.",
          },
        ],
      },
      {
        type: "subsection",
        heading: "3.2 Information Collected Automatically",
        blocks: [
          {
            type: "paragraph",
            text: "When you access or use the Platform, we may automatically collect certain technical and usage information through server logs, analytics tools, and similar technologies.",
          },
          {
            type: "paragraph",
            text: "This may include information about your device, browser, IP address, operating system, Platform activity, pages visited, session duration, clickstream data, and other technical information that enables us to maintain the security, functionality, and performance of the Platform.",
          },
        ],
      },
      {
        type: "subsection",
        heading: "3.3 Information Received from Third Parties",
        blocks: [
          {
            type: "paragraph",
            text: "We may receive Personal Data from:",
          },
          {
            type: "list",
            items: [
              "Clients using the Platform where they submit information relating to candidates or recruitment activities;",
              "authorized payment service providers in connection with payment verification;",
              "publicly available professional sources where relevant to recruitment services requested by you;",
              "regulatory authorities or public bodies where disclosure is authorized or required by law; and",
              "other third parties where you have authorized such disclosure or where such disclosure is otherwise permitted under Applicable Data Protection Laws.",
            ],
          },
          {
            type: "paragraph",
            text: "Where we receive your Personal Data from a third party, we will process such information in accordance with Applicable Data Protection Laws and this Privacy Policy.",
          },
        ],
      },
      {
        type: "subsection",
        heading: "3.4 Information Generated Through Your Use of the Platform",
        blocks: [
          {
            type: "paragraph",
            text: "We may generate or derive certain information through your interaction with the Platform, including information produced by our artificial intelligence systems and assessment tools.",
          },
          {
            type: "paragraph",
            text: "Such information may include candidate matching results, role-fit recommendations, skills analyses, behavioural insights, psychometric profiles, recruitment analytics, and other outputs generated from information you provide or your interactions with the Platform.",
          },
          {
            type: "paragraph",
            text: "These AI-generated outputs are intended to support recruitment and talent assessment processes and are used in conjunction with appropriate human review rather than as the sole basis for significant employment-related decisions.",
          },
        ],
      },
    ],
  },

  {
    title: "PURPOSES FOR WHICH WE PROCESS PERSONAL DATA",
    blocks: [
      {
        type: "paragraph",
        text: "We process Personal Data only where it is necessary for legitimate and lawful purposes connected with the operation of the Platform and the provision of our services. Depending on your relationship with Awasource, we may process your Personal Data for one or more of the following purposes:",
      },
      {
        type: "subsection",
        heading: "4.1 To Create and Manage User Accounts",
        blocks: [
          {
            type: "paragraph",
            text: "We process Personal Data to create, verify, administer, maintain, and secure user accounts, authenticate users, facilitate access to the Platform, and provide ongoing account management services.",
          },
        ],
      },
      {
        type: "subsection",
        heading: "4.2 To Deliver Recruitment and Talent Intelligence Services",
        blocks: [
          {
            type: "paragraph",
            text: "We process Personal Data to facilitate recruitment activities, connect Talents with prospective employers, assess candidate suitability, recommend opportunities, enable employers to identify qualified candidates, and otherwise provide the recruitment and talent intelligence services offered through the Platform.",
          },
        ],
      },
      {
        type: "subsection",
        heading: "4.3 To Conduct Assessments and Generate AI-Assisted Insights",
        blocks: [
          {
            type: "paragraph",
            text: "We process Personal Data to administer psychometric, technical, behavioural, aptitude, and other assessments, analyse assessment results, generate AI-assisted insights, produce role-fit recommendations, and support recruitment decision-making.",
          },
          {
            type: "paragraph",
            text: "AI-generated outputs are intended to assist users and Clients in making informed recruitment decisions and are not designed to replace appropriate human judgment or serve as the sole basis for employment-related decisions.",
          },
        ],
      },
      {
        type: "subsection",
        heading: "4.4 To Verify Identity and Conduct Customer Due Diligence",
        blocks: [
          {
            type: "paragraph",
            text: "We may process your Personal Data to verify your identity or the identity of the organisation you represent, confirm the accuracy of information provided during onboarding, conduct reasonable customer due diligence, prevent fraud and misuse of the Platform, and maintain the integrity and security of our recruitment services.",
          },
        ],
      },
      {
        type: "subsection",
        heading: "4.5 To Facilitate Transactions and Process Payments",
        blocks: [
          {
            type: "paragraph",
            text: "We process Personal Data to facilitate transactions made through the Platform, verify and process payments through authorised third-party payment service providers, maintain accurate transaction records, administer billing-related matters, prevent fraudulent or unauthorised transactions, and otherwise provide and manage paid services available on the Platform.",
          },
        ],
      },
      {
        type: "subsection",
        heading: "4.6 To Communicate with You",
        blocks: [
          {
            type: "paragraph",
            text: "We process Personal Data to communicate with you regarding your account, recruitment activities, Platform updates, security notifications, customer support enquiries, technical issues, service announcements, promotional communications (where permitted by law), and other matters relating to your use of the Platform.",
          },
          {
            type: "paragraph",
            text: "Where required by Applicable Data Protection Laws, we will obtain your consent before sending direct marketing communications, and you may opt out of such communications at any time.",
          },
        ],
      },
      {
        type: "subsection",
        heading: "4.7 To Improve, Maintain, and Secure the Platform",
        blocks: [
          {
            type: "paragraph",
            text: "We process Personal Data to monitor Platform performance, identify and resolve technical issues, improve our products and services, develop new features, enhance user experience, maintain system security, detect fraudulent or malicious activity, and protect the integrity, availability, and confidentiality of the Platform.",
          },
        ],
      },
      {
        type: "subsection",
        heading: "4.8 To Comply with Legal and Regulatory Obligations",
        blocks: [
          {
            type: "paragraph",
            text: "We may process Personal Data where necessary to comply with applicable laws, regulations, lawful requests from competent authorities, court orders, regulatory investigations, audit requirements, tax obligations, and other legal or regulatory responsibilities applicable to Awasource.",
          },
        ],
      },
      {
        type: "subsection",
        heading: "4.9 To Establish, Exercise, or Defend Legal Rights",
        blocks: [
          {
            type: "paragraph",
            text: "Where necessary, we may process Personal Data for the establishment, exercise, or defence of legal claims, dispute resolution, internal investigations, enforcement of our contractual rights, and the protection of the rights, property, safety, and legitimate interests of Awasource, our users, and other third parties.",
          },
        ],
      },
    ],
  },

  {
    title: "LEGAL BASIS FOR PROCESSING",
    blocks: [
      {
        type: "paragraph",
        text: "Awasource processes Personal Data only where it has a lawful basis for doing so under the Nigeria Data Protection Act, 2023 and other Applicable Data Protection Laws. Depending on the nature of the processing activity, we may rely on one or more of the following lawful bases:",
      },
      {
        type: "subsection",
        heading: "5.1 Performance of a Contract",
        blocks: [
          {
            type: "paragraph",
            text: "We process Personal Data where such processing is necessary to enter into or perform a contract with you or to take steps at your request before entering into a contract.",
          },
          {
            type: "paragraph",
            text: "This includes processing necessary to:",
          },
          {
            type: "list",
            items: [
              "create and manage your account;",
              "provide access to the Platform and its features;",
              "facilitate recruitment and talent matching services;",
              "administer assessments;",
              "provide customer support;",
              "process transactions; and",
              "otherwise deliver the services you have requested.",
            ],
          },
        ],
      },
      {
        type: "subsection",
        heading: "5.2 Compliance with Legal Obligations",
        blocks: [
          {
            type: "paragraph",
            text: "We may process Personal Data where such processing is necessary to comply with legal or regulatory obligations applicable to Awasource.",
          },
          {
            type: "paragraph",
            text: "This may include processing required to:",
          },
          {
            type: "list",
            items: [
              "comply with applicable laws and regulations;",
              "respond to lawful requests from courts, regulators, law enforcement agencies, or other competent authorities;",
              "maintain records required by law;",
              "comply with tax, accounting, audit, and reporting obligations; and",
              "investigate or prevent unlawful activities where required or authorised by law.",
            ],
          },
        ],
      },
      {
        type: "subsection",
        heading: "5.3 Legitimate Interests",
        blocks: [
          {
            type: "paragraph",
            text: "We may process Personal Data where such processing is necessary for our legitimate interests or those of a third party, provided that such interests are not overridden by your fundamental rights and freedoms.",
          },
          {
            type: "paragraph",
            text: "Our legitimate interests may include:",
          },
          {
            type: "list",
            items: [
              "improving and developing the Platform;",
              "maintaining the security, integrity, and availability of our systems;",
              "detecting, investigating, and preventing fraud, abuse, or other unlawful activities;",
              "protecting our legal rights and interests;",
              "conducting internal administration, reporting, and business operations;",
              "analysing Platform performance and user engagement; and",
              "improving the quality, reliability, and effectiveness of our recruitment services.",
            ],
          },
          {
            type: "paragraph",
            text: "Where we rely on legitimate interests as a lawful basis, we will take appropriate steps to ensure that our interests are balanced against your rights and freedoms.",
          },
        ],
      },
      {
        type: "subsection",
        heading: "5.4 Consent",
        blocks: [
          {
            type: "paragraph",
            text: "Where required by Applicable Data Protection Laws, we will seek your consent before processing your Personal Data.",
          },
          {
            type: "paragraph",
            text: "Where we rely on consent, you are free to withdraw your consent at any time. Withdrawal of consent shall not affect the lawfulness of any processing carried out before such withdrawal or any processing undertaken on another lawful basis permitted under Applicable Data Protection Laws.",
          },
          {
            type: "paragraph",
            text: "Consent may be relied upon for activities such as:",
          },
          {
            type: "list",
            items: [
              "sending direct marketing communications where required by law;",
              "processing certain categories of Sensitive Personal Data, where required;",
              "placing non-essential cookies or similar technologies, where applicable; and",
              "any other processing activity for which consent is required under Applicable Data Protection Laws.",
            ],
          },
        ],
      },
    ],
  },

  {
    title: "AI PROCESSING AND PROFILING",
    blocks: [
      {
        type: "paragraph",
        text: `As part of our recruitment and talent intelligence services, Awasource uses artificial intelligence ("AI"), and other automated processing tools to assist in analysing information provided by users and generating insights that support recruitment and talent management processes.`,
      },
      {
        type: "paragraph",
        text: "Our AI systems may process Personal Data to:",
      },
      {
        type: "list",
        items: [
          "analyse information contained in user profiles, curriculum vitae (CVs), résumés, assessments, and other recruitment-related materials;",
          "evaluate skills, competencies, qualifications, and experience relevant to particular roles;",
          "generate candidate suitability assessments and role-fit recommendations;",
          "identify potential matches between Talents and Clients;",
          "produce recruitment insights and analytics; and",
          "improve the functionality, accuracy, and effectiveness of our Platform and related services.",
        ],
      },
      {
        type: "paragraph",
        text: "AI-generated outputs, including candidate scores, recommendations, rankings, behavioural insights, psychometric analyses, and other automated assessments, are intended solely to assist users in making informed recruitment decisions.",
      },
      {
        type: "paragraph",
        text: "Awasource does not use AI systems as the sole basis for making decisions that produce legal or similarly significant effects on individuals. Employment, recruitment, engagement, promotion, compensation, termination, and other significant workforce decisions remain subject to meaningful human review and are made by the relevant Client or authorised decision-maker.",
      },
      {
        type: "paragraph",
        text: "While we take reasonable steps to promote the accuracy, fairness, reliability, and continuous improvement of our AI systems, AI-generated outputs are based on the information available at the time of processing and may not always be complete, accurate, or free from error. Users should therefore exercise independent judgment and consider all relevant information before relying on AI-generated outputs.",
      },
      {
        type: "paragraph",
        text: "Where required under Applicable Data Protection Laws, users may request additional information regarding our use of automated processing, seek correction of inaccurate Personal Data, or exercise any other rights available to them under applicable law.",
      },
    ],
  },

  {
    title: "DATA SHARING AND DISCLOSURE",
    blocks: [
      {
        type: "paragraph",
        text: "Awasource treats your Personal Data as confidential and does not sell, rent, or otherwise disclose your Personal Data except as described in this Privacy Policy, where required or permitted by law, or where you have otherwise authorised such disclosure.",
      },
      {
        type: "paragraph",
        text: "Depending on the circumstances, we may share your Personal Data with the following categories of recipients:",
      },
      {
        type: "subsection",
        heading: "7.1 Clients and Prospective Employers",
        blocks: [
          {
            type: "paragraph",
            text: "Where you use the Platform as a Talent, certain Personal Data may be shared with Clients for legitimate recruitment, talent assessment, and hiring purposes.",
          },
          {
            type: "paragraph",
            text: "As a privacy safeguard, candidate profiles may initially be presented in a manner that limits or conceals identifying information. Identifying Personal Data may only be disclosed to a Client where such disclosure is necessary to facilitate the recruitment process or where the Client has lawfully unlocked, matched with, or otherwise obtained authorised access to the relevant Talent's profile through the Platform.",
          },
          {
            type: "paragraph",
            text: "Clients receiving Personal Data through the Platform are expected to process such information responsibly and in accordance with applicable data protection laws.",
          },
        ],
      },
      {
        type: "subsection",
        heading: "7.2 Service Providers",
        blocks: [
          {
            type: "paragraph",
            text: "We may share Personal Data with carefully selected third-party service providers that perform services on our behalf and support the operation of the Platform.",
          },
          {
            type: "paragraph",
            text: "Such service providers may include providers of:",
          },
          {
            type: "list",
            items: [
              "cloud hosting and infrastructure services;",
              "payment processing services;",
              "cybersecurity and fraud prevention services;",
              "data storage and backup services;",
              "customer support services;",
              "communication and email delivery services;",
              "analytics and system monitoring services; and",
              "other technology services necessary for the operation, maintenance, and improvement of the Platform.",
            ],
          },
          {
            type: "paragraph",
            text: "Where third-party service providers process Personal Data on our behalf, they are required to process such information only in accordance with our instructions, applicable contractual obligations, and Applicable Data Protection Laws.",
          },
        ],
      },
      {
        type: "subsection",
        heading: "7.3 Professional Advisers",
        blocks: [
          {
            type: "paragraph",
            text: "We may disclose Personal Data where reasonably necessary to our professional advisers, including legal advisers, auditors, consultants, insurers, and other professional service providers, where such disclosure is necessary for the provision of professional services or the protection of our legal interests.",
          },
        ],
      },
      {
        type: "subsection",
        heading: "7.4 Regulatory Authorities and Law Enforcement",
        blocks: [
          {
            type: "paragraph",
            text: "We may disclose Personal Data where we believe such disclosure is necessary or appropriate to:",
          },
          {
            type: "list",
            items: [
              "comply with applicable laws, regulations, or legal obligations;",
              "comply with lawful requests, court orders, subpoenas, or other legal processes;",
              "cooperate with regulatory authorities or law enforcement agencies;",
              "establish, exercise, or defend legal claims;",
              "investigate suspected fraud, unlawful conduct, or security incidents; or",
              "protect the rights, property, safety, or legitimate interests of Awasource, our users, or other persons.",
            ],
          },
        ],
      },
      {
        type: "subsection",
        heading: "7.5 Corporate Transactions",
        blocks: [
          {
            type: "paragraph",
            text: "Where Awasource is involved in a proposed or completed merger, acquisition, investment, financing, business restructuring, asset sale, or similar corporate transaction, Personal Data may be disclosed to prospective or actual purchasers, investors, financiers, advisers, or other relevant parties, subject to appropriate confidentiality obligations and Applicable Data Protection Laws.",
          },
        ],
      },
      {
        type: "subsection",
        heading: "7.6 With Your Consent or at Your Direction",
        blocks: [
          {
            type: "paragraph",
            text: "We may disclose your Personal Data to other persons or organisations where you have expressly authorised us to do so or where you instruct us to facilitate such disclosure.",
          },
          {
            type: "paragraph",
            text: "We take reasonable steps to ensure that recipients of Personal Data are subject to appropriate confidentiality, security, and data protection obligations commensurate with the nature of the Personal Data disclosed.",
          },
        ],
      },
    ],
  },

  {
    id: "marketing-forms",
    title: "BROCHURE, CALCULATOR AND ENQUIRY FORMS",
    blocks: [
      {
        type: "paragraph",
        text: "Our website has forms that people who are not yet customers can use: the partner brochure download, the screening-time calculator, and the partnership enquiry (\"Request a call\") form. We may also receive the same details when you complete a lead form for one of our adverts on LinkedIn.",
      },
      {
        type: "subsection",
        heading: "What we collect",
        blocks: [
          {
            type: "list",
            items: [
              "your name, work email address and company name;",
              "what you tell us about your hiring, such as how many candidates you assess each month, or the figures you enter in the calculator;",
              "whether you ticked the box to receive follow-up emails, and when;",
              "how you reached us: the advert or campaign (UTM tags), the page you landed on and, where you arrived from an advert, the advertising platform's click identifier.",
            ],
          },
        ],
      },
      {
        type: "subsection",
        heading: "How we use it",
        blocks: [
          {
            type: "list",
            items: [
              "to send what you asked for: the brochure link, your calculator result, or a reply to your enquiry. We send these whether or not you tick the follow-up box;",
              "to tell our team that a request has come in, so the right person can respond;",
              "if you tick the box: to send a short series of follow-up emails about the Awasource Partner Portal (for example a sample assessment report and how partners go live) and occasional hiring insights. Every one of these emails has an unsubscribe link, and unsubscribing stops the series straight away;",
              "to understand which adverts and pages bring useful enquiries, so we can spend our advertising budget well.",
            ],
          },
          {
            type: "paragraph",
            text: "We do not sell these details, and we do not add you to marketing emails unless you tick the box. Ticking the box is never a condition of getting the brochure or your result.",
          },
        ],
      },
      {
        type: "subsection",
        heading: "Who handles it",
        blocks: [
          {
            type: "paragraph",
            text: "Form submissions are stored on our cloud infrastructure and the emails are sent through our email delivery provider. Both act on our instructions only. If you used a LinkedIn lead form, LinkedIn's own privacy policy also applies to the details you entered there.",
          },
        ],
      },
      {
        type: "subsection",
        heading: "How long we keep it",
        blocks: [
          {
            type: "paragraph",
            text: "We keep form submissions for up to 24 months after our last contact with you, unless you become a customer or partner (when the rest of this Policy applies) or ask us to delete them sooner. If you unsubscribe, we keep your email address on a suppression list so that we do not email you again.",
          },
        ],
      },
    ],
  },
  {
    id: "cookies",
    title: "COOKIES AND SIMILAR TECHNOLOGIES",
    blocks: [
      {
        type: "paragraph",
        text: "We use cookies and similar technologies (such as your browser's local storage) on our website. Some are essential; the others only run with your permission where the law requires it.",
      },
      {
        type: "subsection",
        heading: "Essential",
        blocks: [
          {
            type: "paragraph",
            text: "Needed for the website to work: keeping you signed in, security, and remembering your cookie choice. These cannot be switched off.",
          },
        ],
      },
      {
        type: "subsection",
        heading: "Analytics",
        blocks: [
          {
            type: "paragraph",
            text: "Google Analytics (through the Google tag and Google Tag Manager) tells us how visitors use the site. We also remember, in your browser, which advert or campaign first brought you to us, so we can tell which campaigns lead to sign-ups and enquiries.",
          },
        ],
      },
      {
        type: "subsection",
        heading: "Advertising",
        blocks: [
          {
            type: "paragraph",
            text: "Google Ads and the Meta (Facebook and Instagram) pixel measure whether our adverts lead to sign-ups, enquiries and brochure downloads, and let us show our adverts to people who have visited our site. These providers may combine this with information they already hold about you, under their own privacy policies.",
          },
        ],
      },
      {
        type: "subsection",
        heading: "Your choices",
        blocks: [
          {
            type: "paragraph",
            text: "The first time you visit, a banner lets you accept or reject analytics and advertising cookies, or choose each one. If you are in the United Kingdom, the European Economic Area or Switzerland, they stay off until you accept. Elsewhere they are on by default and you can turn them off. You can change your choice at any time through the \"Cookie settings\" link at the bottom of our pages. You can also block or delete cookies in your browser settings.",
          },
        ],
      },
    ],
  },
  {
    id: "uk-eu",
    title: "VISITORS IN THE UNITED KINGDOM AND EUROPEAN UNION",
    blocks: [
      {
        type: "paragraph",
        text: "If you are in the United Kingdom or the European Economic Area, the UK GDPR or the EU General Data Protection Regulation also applies when we process your Personal Data, in addition to the laws listed in the Introduction.",
      },
      {
        type: "subsection",
        heading: "Legal bases",
        blocks: [
          {
            type: "list",
            items: [
              "<strong>Taking steps at your request</strong>: sending you the brochure, your calculator result, or a reply to your enquiry;",
              "<strong>Legitimate interests</strong>: alerting our team to your request, keeping records of it, and understanding which of our campaigns work. We have balanced these interests against your rights, and you can object at any time;",
              "<strong>Consent</strong>: follow-up marketing emails, and analytics and advertising cookies. You can withdraw consent at any time, without affecting anything we did before.",
            ],
          },
        ],
      },
      {
        type: "subsection",
        heading: "International transfers",
        blocks: [
          {
            type: "paragraph",
            text: "Awasource is based in Nigeria, and some of our service providers are in other countries, including the United States. When we transfer Personal Data out of the UK or the European Economic Area to a country that does not have an adequacy decision, we rely on appropriate safeguards such as the European Commission's standard contractual clauses or the UK International Data Transfer Agreement or Addendum.",
          },
        ],
      },
      {
        type: "subsection",
        heading: "Your rights and complaints",
        blocks: [
          {
            type: "paragraph",
            text: "You have the rights described in the next section, including the right to object to processing based on legitimate interests and to object to direct marketing at any time. You can also complain to the Information Commissioner's Office (ico.org.uk) in the UK, or to the data protection authority in the EU country where you live or work. We would appreciate the chance to deal with your concern first, at privacy@awasource.com.",
          },
        ],
      },
    ],
  },
  {
    title: "YOUR RIGHTS AS A DATA SUBJECT",
    blocks: [
      {
        type: "paragraph",
        text: "Subject to the Nigeria Data Protection Act, 2023 and other Applicable Data Protection Laws, you have certain rights in relation to your Personal Data.",
      },
      {
        type: "paragraph",
        text: "These include the right to:",
      },
      {
        type: "list",
        items: [
          "request access to the Personal Data we hold about you;",
          "request the correction of inaccurate, incomplete, or outdated Personal Data;",
          "withdraw your consent where processing is based on your consent;",
          "object to or request the restriction of the processing of your Personal Data, subject to applicable legal limitations;",
          "request that your Personal Data be provided to you in a structured, commonly used, and machine-readable format, or be transferred to another organisation where technically feasible;",
          "request the deletion of your Personal Data, subject to any legal, regulatory, or operational obligations requiring us to retain certain information.",
        ],
      },
      {
        type: "paragraph",
        text: "You may exercise your rights by contacting us using the details provided in the Contact Us section of this Privacy Policy.",
      },
      {
        type: "paragraph",
        text: "If you believe that your Personal Data has been processed in a manner that is inconsistent with Applicable Data Protection Laws, you may lodge a complaint with the Nigeria Data Protection Commission (NDPC) or contact Awasource using the details provided in this Privacy Policy so that we may address your concerns.",
      },
    ],
  },

  {
    title: "DATA SECURITY",
    blocks: [
      {
        type: "paragraph",
        text: "We are committed to protecting your Personal Data and implement appropriate technical and organisational measures designed to safeguard it against accidental or unlawful destruction, loss, alteration, unauthorised disclosure, or access.",
      },
      {
        type: "paragraph",
        text: "Our security measures include the use of secure cloud infrastructure, access controls, continuous system monitoring, and other appropriate safeguards designed to protect the confidentiality, integrity, and availability of Personal Data processed through the Platform.",
      },
      {
        type: "paragraph",
        text: "While we take reasonable steps to protect your Personal Data, no method of electronic transmission or storage is completely secure. Accordingly, we cannot guarantee the absolute security of your Personal Data.",
      },
      {
        type: "paragraph",
        text: "If you become aware of any actual or suspected unauthorised access to your account or Personal Data, you should notify us immediately using the contact details provided in this Privacy Policy.",
      },
    ],
  },

  {
    title: "DATA RETENTION",
    blocks: [
      {
        type: "paragraph",
        text: "We retain your Personal Data only for as long as is reasonably necessary to fulfil the purposes for which it was collected, including providing our services, complying with applicable legal and regulatory obligations, resolving disputes, enforcing our legal rights, and preventing fraud or misuse of the Platform.",
      },
      {
        type: "paragraph",
        text: "Where you delete your account or request the deletion of your Personal Data, we will take reasonable steps to delete or anonymise your Personal Data, unless we are required or permitted to retain certain information in accordance with applicable law.",
      },
      {
        type: "paragraph",
        text: "We will securely destroy your Personal Data when retention is no longer required for the purpose for which it was collected or where we are no longer under any legal or regulatory obligation to retain such Personal Data.",
      },
    ],
  },

  {
    title: "CHILDREN'S PRIVACY",
    blocks: [
      {
        type: "paragraph",
        text: "The Platform is intended for individuals who are at least eighteen (18) years of age and is not designed or directed at children.",
      },
      {
        type: "paragraph",
        text: "We do not knowingly collect or process the Personal Data of individuals under the age of eighteen (18). If we become aware that we have inadvertently collected Personal Data from a person under the age of eighteen (18), we will take reasonable steps to delete such Personal Data or otherwise process it in accordance with Applicable Data Protection Laws.",
      },
      {
        type: "paragraph",
        text: "If you believe that a child has provided Personal Data through the Platform, please contact us using the details provided in the Contact Us section of this Privacy Policy.",
      },
    ],
  },

  {
    title: "THIRD-PARTY LINKS",
    blocks: [
      {
        type: "paragraph",
        text: "The Platform may contain links to third-party websites, applications, products, or services that are not owned or controlled by Awasource.",
      },
      {
        type: "paragraph",
        text: "This Privacy Policy does not apply to the privacy practices of such third parties. We encourage you to review the privacy policies and terms of use of any third-party websites or services you access through the Platform before providing your Personal Data.",
      },
    ],
  },

  {
    title: "UPDATES TO THIS POLICY",
    blocks: [
      {
        type: "paragraph",
        text: "We may update this Privacy Policy from time to time to reflect changes in our business operations, legal or regulatory requirements, or the manner in which we process Personal Data.",
      },
      {
        type: "paragraph",
        text: "Material changes to this Privacy Policy will be reflected by updating this page and revising the effective date. Where required by Applicable Data Protection Laws, we will notify you of such changes.",
      },
      {
        type: "paragraph",
        text: "We encourage you to review this Privacy Policy periodically to remain informed about how we collect, use, and protect your Personal Data.",
      },
    ],
  },

  {
    title: "CONTACT INFORMATION",
    blocks: [
      {
        type: "paragraph",
        text: "Awasource<br/>1 Adebiyi Mobolaji Street, Abuja, Nigeria<br/><br/>Email: privacy@awasource.com<br/>Support: support@awasource.com",
      },
    ],
  },
];

export const TABLEARRAY = [
  {
    tab1: "A",
    tab2: "Identifiers",
    tab3: "Contact details, such as real name, alias, postal address, telephone or mobile contact number, unique personal identifier, online identifier, Internet Protocol address, email address and account name",
    tab4: "NO",
  },
  {
    tab1: "B",
    tab2: "Personal information categories listed in the California Customer Records statute",
    tab3: "Name, contact information, education, employment, employment history and financial information",
    tab4: "YES",
  },
  {
    tab1: "C",
    tab2: "Protected classification characteristics under California or federal law",
    tab3: "Gender and date of birth",
    tab4: "NO",
  },
  {
    tab1: "D",
    tab2: "Commercial information",
    tab3: "Transaction information, purchase history, financial details and payment information",
    tab4: "NO",
  },
  {
    tab1: "E",
    tab2: "Biometric information",
    tab3: "Fingerprints and voiceprints",
    tab4: "NO",
  },
  {
    tab1: "F",
    tab2: "Internet or other similar network activity",
    tab3: "Browsing history, search history, online behavior, interest data, and interactions with our and other websites, applications, systems and advertisements",
    tab4: "NO",
  },
  {
    tab1: "G",
    tab2: "Geolocation data",
    tab3: "Device location",
    tab4: "NO",
  },
  {
    tab1: "H",
    tab2: "Audio, electronic, visual, thermal, olfactory, or similar information",
    tab3: "Images and audio, video or call recordings created in connection with our business activities",
    tab4: "NO",
  },
  {
    tab1: "I",
    tab2: "Professional or employment-related information",
    tab3: "Business contact details in order to provide you our services at a business level, job title as well as work history and professional qualifications if you apply for a job with us",
    tab4: "NO",
  },
  {
    tab1: "J",
    tab2: "Education Information",
    tab3: "Student records and directory information",
    tab4: "NO",
  },
  {
    tab1: "K",
    tab2: "Inferences drawn from other personal information",
    tab3: "Inferences drawn from any of the collected personal information listed above to create a profile or summary about, for example, an individual's preferences and characteristics",
    tab4: "YES",
  },
];
export const ALL_SKILLS = [
  "Accounting",
  "Accounting Software",
  "Accounting Software eg Quickbooks",
  "Adobe Illustrator",
  "Adobe InDesign",
  "Adobe Photoshop",
  "Adobe Software (Photoshop, InDesign, Illustrator, etc.)",
  "Agile",
  "Algorithms",
  "Analytical Skills",
  "Analytical Thinking",
  "Ansible",
  "API Development",
  "API Integration",
  "API Testing",
  "Applications",
  "Artificial Intelligence",
  "Artificial Intelligence (AI)",
  "Asset Allocation",
  "Attention to Detail",
  "Auditing",
  "Automation",
  "Automated Marketing Software",
  "AWS",
  "Azure",
  "Benchmarking",
  "Big Data",
  "Blogging",
  "Blueprint Design",
  "Bookkeeping",
  "Brand Management",
  "Branding",
  "Budget Planning",
  "Budgeting",
  "Bug Tracking",
  "Business Acumen",
  "Business Analysis",
  "Business Development",
  "C++",
  "C#",
  "CI/CD",
  "Calculating",
  "Calendar Management",
  "Call Handling",
  "Campaign Management",
  "Campaign Planning",
  "Cash Handling",
  "Certifications",
  "Client Management",
  "Client Relations",
  "Client Relationship Management",
  "Cloud/SaaS Services",
  "Coaching",
  "Coding",
  "Collaboration",
  "Communication",
  "Compiling Statistics",
  "Compliance",
  "Computing",
  "Configuration",
  "Confidentiality",
  "Conflict Resolution",
  "Content Creation",
  "Content Management Systems (CMS)",
  "Content Marketing",
  "Content Strategy",
  "Contract Management",
  "Copywriting",
  "Creativity",
  "CRM",
  "CRM Tools",
  "Cross-Selling",
  "Customer Engagement",
  "Customer Relationship Management (CRM)",
  "Customer Service",
  "Customer Support",
  "Data Analysis",
  "Data Analytics",
  "Data Cleaning",
  "Data Entry",
  "Data Mining",
  "Data Modeling",
  "Data Visualization",
  "Database Design",
  "Database Design and Management",
  "Database Management",
  "Database Software",
  "Debugging",
  "Decision Making",
  "Defect Reporting",
  "Design",
  "Design Thinking",
  "Development",
  "Diagnostics",
  "Digital Marketing",
  "Digital Media",
  "Digital Photography",
  "Django",
  "Dispensing",
  "Docker",
  "Documentation",
  "Drug Interactions",
  "Editing",
  "Electrical Systems",
  "Email",
  "Email Campaigns",
  "Email Support",
  "Empathy",
  "Engineering",
  "Engineering Knowledge",
  "Engineering Programs (CAD)",
  "Enterprise Resource Planning (ERP) Software",
  "Ethics",
  "Excel",
  "Executive Support",
  "Fabrication",
  "Facebook",
  "Figma",
  "Financial Analysis",
  "Financial Management",
  "Financial Planning",
  "Financial Reporting",
  "Flask",
  "Following Specifications",
  "Forecasting",
  "Frontend Development",
  "Functional Testing",
  "Fund Transfers",
  "Git",
  "Google Analytics",
  "Google Cloud",
  "Google Suite",
  "Graphic Design",
  "GraphQL",
  "Hardware",
  "Hardware Description Language (HDL)",
  "Hardware Verification Tools and Techniques",
  "Healthcare Collaboration",
  "HelloSign",
  "HR Policies",
  "HRIS",
  "HTML",
  "Human Resources Software",
  "Hydraulics",
  "ICT (Information and Communications Technology)",
  "Illustration",
  "Implementation",
  "Influence",
  "Information Management",
  "Information Security",
  "Information Technology",
  "Infrastructure",
  "Integrity",
  "Instagram",
  "Interaction Design",
  "Internal Controls",
  "Inventory Control",
  "Inventory Management",
  "iOS Development",
  "J Query",
  "Java",
  "JavaScript",
  "Jenkins",
  "Jira",
  "Kotlin",
  "KPI Tracking",
  "Kubernetes",
  "KYC",
  "Labor Law Compliance",
  "Ladder",
  "Languages",
  "Layout Design",
  "Leadership",
  "Lead Generation",
  "LinkedIn",
  "LinkedIn Recruiting",
  "Linux",
  "Logistics",
  "Machine Learning",
  "Machine Maintenance",
  "Maintenance",
  "Manual Testing",
  "Manufacturing",
  "Market Analysis",
  "Market Research",
  "Marketing Strategy",
  "Mathematical Ability",
  "Mechanical Maintenance",
  "Medical Billing",
  "Medical Coding",
  "Mentoring",
  "Merchandising",
  "Metrics Reporting",
  "Microsoft Office",
  "Microsoft Office (Word, Excel, Powerpoint, etc.)",
  "Microsoft Office Certifications",
  "Modeling",
  "Modification",
  "MongoDB",
  "Multitasking",
  "MySQL",
  "Needs Analysis",
  "Negotiation",
  "Network Architecture",
  "Network Security",
  "Networking",
  "New Technologies",
  "Node JS",
  "Node.js",
  "NoSQL",
  "Numeracy",
  "Onboarding",
  "Operating Systems",
  "Optimization",
  "Operations",
  "Operations Management",
  "Organization",
  "Performance Management",
  "Performance Optimization",
  "Performance Review",
  "Performance Tracking",
  "PHP",
  "Pneumatics",
  "Point of Sale Systems (Harbortouch, Clover, etc.)",
  "Portfolio Management",
  "PostgreSQL",
  "Postman",
  "Power BI",
  "Presentation",
  "Preventive Maintenance",
  "Problem Solving",
  "Process Mapping",
  "Process Optimization",
  "Product Knowledge",
  "Product Management",
  "Product Strategy",
  "Productivity Software",
  "Professionalism",
  "Program Management",
  "Programming",
  "Project Management",
  "Project Planning",
  "Proofreading",
  "Proposal Writing",
  "Prototyping",
  "Public Relations",
  "Python",
  "Quantitative Reports",
  "Quantitative Research",
  "Quality Assurance",
  "Quality Control",
  "Query Software",
  "QuickBooks",
  "React",
  "React Native",
  "Recruitment",
  "Regression Testing",
  "Reliability",
  "Reporting",
  "Research",
  "Requirements Gathering",
  "Resource Allocation",
  "Responsive Design",
  "REST",
  "RESTful APIs",
  "Retail Management",
  "Risk Analysis",
  "Risk Management",
  "Routing & Navigation",
  "R",
  "Ruby",
  "SAS",
  "Sales",
  "Sales Strategy",
  "Scheduling",
  "Scrum",
  "Search Engine Optimization (SEO)",
  "Security",
  "Selenium",
  "Servers",
  "Site Acquisition",
  "Sketch",
  "Slack",
  "Social Media",
  "Social Media Management",
  "Social Media Marketing",
  "Software",
  "Software Testing",
  "Solution Delivery",
  "Solution Design",
  "Sonography",
  "Source Control (Git)",
  "SPARK",
  "Spreadsheets",
  "SQL",
  "Stakeholder Management",
  "Statistical Analysis",
  "Storage",
  "Storytelling",
  "Strategic Planning",
  "Structural Analysis",
  "Structures",
  "Subject Matter Experts (SMEs)",
  "Swift",
  "Systems Analysis",
  "Tableau",
  "Talent Acquisition",
  "Talent Management",
  "Task Delegation",
  "Task Management",
  "Tax Compliance",
  "Team Coordination",
  "Team Leadership",
  "Teamwork",
  "Technical Sales",
  "Technical Support",
  "Technical Writing",
  "Technical Documentation",
  "Technology",
  "Telecommunications",
  "Terraform",
  "Test Automation",
  "Test Case Design",
  "Test Management",
  "Testing",
  "Testing Frameworks",
  "Time Management",
  "Tools",
  "Tools Handling",
  "Training",
  "Training and Development",
  "Travel Coordination",
  "Troubleshooting",
  "Twitter",
  "Typography",
  "UI/UX Principles",
  "Usability",
  "Usability Testing",
  "User Experience (UX)",
  "User Research",
  "User Stories",
  "Version Control",
  "Video Creation",
  "Video Editing",
  "Visual Design",
  "Vue.js",
  "Warehouse Management",
  "Web Analytics",
  "Web Development",
  "Wireframing",
  "Workflow Optimization",
  "WordPress",
  "Workplace Safety",
  "Writing",
  "Zendesk",
  "Zoom"
];

export const PRIMARY_SKILLS = [
  "React",
  "JavaScript",
  "Node JS",
  "CSS",
  "Tailwind",
  "Python",
  "Solidity",
  "Next JS",
  "Angular",
  "Vue JS",
  "Swift",
  "C++",
  "C#",
  "PHP",
  "TypeScript",
  "Scala",
  "Shell",
  "PowerShell",
  "Rust",
  "Ruby",
  "Go",
  "Solidity",
];

export const SECONDARY_SKILLS = [
  "Team Player",
  "Attentive",
  "Coding",
  "Listener",
  "Fast",
];

export const TECH_SKILLS = [
  "Designers",
  "Product Managers",
  "Product Developers",
  "UI/UX designers",
  "Architects",
  "Project Managers",
  "Accountants",
  "Data Analyst",
  "Business Analyst",
  "Financial Analysts",
  "Marketing Manager",
  "Product Designers",
  "Digital Marketers",
  "Writers",
  "Content Creators",
  "Tutors",
  "Artists",
  "Visual creators",
  "I.T Specialists",
  "Information security",
  "Networking Hardware specialist",
  "Frontend Development",
  "Backend Development"
]

export const INDUSTRY_SUGGESTIONS = [
  "Accounting",
  "Advertising",
  "Aerospace",
  "Agriculture",
  "Artificial Intelligence",
  "Automotive",
  "Aviation",
  "Banking",
  "Biotechnology",
  "Blockchain",
  "Cloud Computing",
  "Consulting",
  "Construction",
  "Cryptocurrency",
  "Cybersecurity",
  "Data Science",
  "Defence",
  "Digital Marketing",
  "E-Commerce",
  "EdTech",
  "Education",
  "Energy",
  "Engineering",
  "Entertainment",
  "Environmental Services",
  "Fashion",
  "Financial Services",
  "Fintech",
  "Food & Beverage",
  "Gaming",
  "Government & Public Sector",
  "Healthcare",
  "Hospitality",
  "Human Resources",
  "Information Technology",
  "Insurance",
  "IT Infrastructure",
  "Legal Services",
  "Logistics & Supply Chain",
  "Machine Learning",
  "Manufacturing",
  "Media",
  "Mining",
  "Non-Profit",
  "Oil & Gas",
  "Pharmaceuticals",
  "Publishing",
  "Real Estate",
  "Renewable Energy",
  "Research & Development",
  "Retail",
  "Robotics",
  "Software & Data",
  "Sports & Fitness",
  "Telecommunications",
  "Tourism & Travel",
  "Transportation",
  "Web Development",
];


export const PRIMARY_ROLES = [
  "Software Engineer",
  "Designer",
  "Product Manager",
  "Product Developer",
  "UI/UX Designer",
  "Architect",
  "Project Manager",
  "Accountant",
  "Data Analyst",
  "Business Analyst",
  "Financial Analyst",
  "Marketing Manager",
  "Product Designer",
  "Digital Marketer",
  "Writer",
  "Content Creator",
  "Tutor",
  "Artist",
  "Visual Creator",
  "I.T Specialist",
  "Information Security Specialist",
  "Networking Hardware Specialist"
];

export const Frontend = [];

export const TEAM_MEMORIAL = {
  picture: stanley,
  name: "Stanley Abah",
  role: "Fmr. Head of Innovation & Security · In memoriam, April 2022",
  bio: "Our driving force and motivation to successfully deliver this project to the millions of users who need it. Stanley was always giving us next-level ideas and suggestions on ways to make the product better. Stan left this world on April 29th, 2022, and his memory and presence live on strongly with us.",
};

export const THE_TEAM = [
  {
    picture: henry,
    name: "Henry Dimobika",
    role: "Founder, CEO",
    bio: "Henry leads Awasource's product vision, company strategy and the development of its skills verification platform. Super-passionate and relentlessly determined, he doubles as Product Owner and the team's driving force for delivering the product's solutions to the market.",
  },
  {
    picture: gabriel,
    name: "Gabriel Umoh",
    role: "CTO",
    bio: "Gabriel leads the company's technology strategy and engineering direction. A catalyst driven to see the vision become reality, he brings deep full-stack, cross-programming, research and innovation skills — plus a good blend of humour and vibes.",
  },
  {
    picture: "https://api.dicebear.com/9.x/micah/svg?seed=CD-awa&hair=mrClean&facialHair=beard&facialHairProbability=100&glasses=square&glassesProbability=100&baseColor=6b4021&facialHairColor=1c1310&mouth=smile&backgroundColor=eef1f8",
    name: "Chiduluo Dimobika",
    role: "Director",
    bio: "Chiduluo supports the company's governance, operations and strategic development, helping keep Awasource's direction steady and its foundations sound as the business grows.",
  },
  {
    picture: "https://api.dicebear.com/9.x/avataaars/svg?seed=SusanAbah&skinColor=ae5d29&hairColor=2c1b18&top=bob&facialHairProbability=0&eyebrows=defaultNatural&mouth=smile&backgroundColor=eef1f8",
    name: "Susan Abah",
    role: "Legal Counsel & Company Secretary",
    bio: "Susan oversees Awasource's legal, governance and corporate compliance. As Legal Counsel and Company Secretary she helps keep the company's obligations properly met and its corporate foundations sound.",
  },
  {
    picture: gospel,
    name: "Gospel Chinyereugo",
    role: "Senior Fullstack Engineer",
    bio: "Gospel contributes to the architecture and development of the Awasource platform. A worthy final-lap motivator, he makes sure functionality and requirements work exactly as intended, with quality verified — so the team never just does the work and walks away.",
  },
  {
    picture: leo,
    name: "Leo Ohaga",
    role: "Senior Product Engineer",
    bio: "Leo drives product development and the delivery of Awasource's user-facing platform. Our senior man, whose technical nous and speed have pushed the project a long way toward reality — knowing Leo is knowing someone who codes in his sleep, fast and remarkably efficient at it.",
  },
  {
    picture: gregu,
    name: "Greg Udogu",
    role: "Senior Backend Engineer",
    bio: "Greg develops and maintains the platform's backend systems and services. One of our most reliable engineers, he delivers endpoints on the go while juggling challenges like a pro — and is quite possibly the biggest fan of Awasource on the team.",
  },
  {
    picture: ken,
    name: "Ken Agbapuonwu",
    role: "Product Engineer / Designer",
    bio: "A catalyst to our growth on the visual and frontend side. Ken's mantra — that anything worth doing is worth doing well — has been instrumental in Awasource, holding the team to nothing but the highest standards.",
  },
  {
    picture: oderah,
    name: "Oderah Ekweonu",
    role: "UI/UX Designer / Creative",
    bio: "Dedicated, dogged and resilient — a wonderful, hardworking person to work with. Oderah loves this project and the team a lot, and it shows in the work.",
  },
  {
    picture: abayomi,
    name: "Abayomi Bashorun",
    role: "Growth & Partnerships",
    bio: "Yomi brings a wealth of experience in startup growth, technology and business development. Co-founder of Ginjaa and Anglitica (our parent company), he is innovative and knowledgeable — we're happy to have him on board.",
  },
  {
    picture: chika,
    name: "Chika Donnet",
    role: "QA Specialist",
    bio: "Since Chika joined, it's been smooth sailing on everything QA. A dedicated team member — even more dogged and resilient than your typical QA — helping keep quality high across the platform.",
  },
];

export const CLIENT_REVIEWS = [
  {
    message:
      "It was a seamless process working with the Awasource team and I really like how easy it was for me to find the best talents through them",
    image: fisayo,
    name: "Oluwafisayomi Adekanmbi (HR Executive)",
  },
  {
    message:
      "The Awasource system of connecting talent with a client has proven instrumental in helping me get a QA job. Great team work producing results",
    image: ifechukwude,
    name: "Ifechukwude Nwoko (QA Engineer)",
  },
  {
    message:
      "The Awasource system of connecting talent with a client was key in helping me get my current UI/UX Design job. I'm really excited about this. Great job guys.",
    image: ibukun,
    name: "Ibukunoluwa Adura",
  },
  {
    message:
      "It was quite an experience getting to know and benefit from the Awasource model. We enjoyed the productive time with the talent recommended to us. Keep it up guys and looking forward to more collaborations",
    image: anthony,
    name: "The Anthony's Consult",
  },
];

export const AI_INSIGHTS = [
  {
    level: "88",
    text: "Teamwork"
  },
  {
    level: "100",
    text: "Judgement"
  },
  {
    level: "90",
    text: "Adaptability"
  },
  {
    level: "80",
    text: "Communication"
  },

]

export const AI_FEATURES = [
  {
    image: brain,
    name: "Decision Making"
  },
  {
    image: team,
    name: "Teamwork Style"
  },
  {
    image: shield,
    name: "Responsibility"
  },
  {
    image: thunder,
    name: "Adaptability"
  },
  {
    image: chat,
    name: "Communication"
  },
];

export const AI_HOW_IT_WORKS = [
  {
    image: img1,
    name: "Take the psychometric test"
  },
  {
    image: img2,
    name: "Awa-AI analyzes your answers"
  },
  {
    image: img3,
    name: "Receive your AI Insight Profile"
  },
  {
    image: img4,
    name: "Use it to grow and apply smarter"
  },
];

export const AI_WHO_IS_THIS_FOR = [
  {
    image: img5,
    name: "Students & graduates"
  },
  {
    image: img6,
    name: "Working professionals"
  },
  {
    image: img7,
    name: "Career switchers"
  },
  {
    image: img8,
    name: "Curious minds"
  },
];

export const SOCIALS = [
  {
    href: "https://web.facebook.com/awasourcestan",
    image: FacebookIcon,
  },
  {
    href: "https://twitter.com/awasourcestan",
    image: TwitterIcon,
  },
  {
    href: "https://www.linkedin.com/company/awasource/",
    image: LinkedInIcon,
  },
  {
    href: "https://instagram.com/awasourcestan?igshid=ZDdkNTZiNTM=",
    image: InstagramIcon,
  },
];

// Transparent fallback for broken images
export const TRANSPARENT_PIXEL =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8Xw8AAn8B9Z4nX5cAAAAASUVORK5CYII=";

export const WAITLIST_INPUTS = [
  {
    name: "full_name",
    placeholder: "Full Name",
    label: "Full Name",
    errorMessage: "Please fill this field",
    validator: (val) => val?.length > 2,
  },
  {
    name: "company",
    placeholder: "Company Name",
    label: "Company Name",
    errorMessage: "Please fill this field",
    validator: (val) => val?.length > 1,
  },
  {
    name: "email",
    placeholder: "Email Address",
    label: "Email Address",
    errorMessage: "Email address is incorrect",
    validator: (val) => checkMail(val),
  },
];

export const DEFAULT_CLIENT_SUBSCRIPTION = "Quarterly"
export const DEFAULT_TALENT_SUBSCRIPTION = "All Premium Insights"

export const DEFAULT_ERROR_MESSAGE = "Something went wrong, Please check your internet connection and try again."
